// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT, PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const de = {
  demo: {
    title: 'Deutsch',
    introduction:
      "Deutsche Einleitung: Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  docs: {
    hi: 'Hallo',
    description: 'Benötigen Sie Hilfe? \n Schauen Sie in unsere Dokumentation.',
    documentation: 'Dokumentation',
  },
  test: 'Test',
  yes: 'Ja',
  no: 'Nein',
  app: 'App',
  noData: 'Keine Daten vorhanden',
  user: 'Benutzer:in',
  welcomeBack: 'Willkommen zurück bei TerraIndividual',
  darkMode: 'Dunkler Modus',
  lightMode: 'Heller Modus',
  list: 'Liste',
  edit: 'Attribute editieren',
  shop: 'Shop',
  blog: 'Blog',
  post: 'Post',
  mail: 'Mail',
  chat: 'Chat',
  cards: 'Cards',
  posts: 'Posts',
  create: 'Erstellen',
  kanban: 'kanban',
  general: 'Allgemein',
  optional: 'Optional',
  banking: 'banking',
  booking: 'booking',
  profile: 'Profil',
  account: 'Account',
  product: 'Produkt',
  invoice: 'Abrechnung',
  details: 'Details',
  checkout: 'abmelden',
  calendar: 'Kalender',
  analytics: 'Analyse',
  ecommerce: 'E-Commerce',
  management: 'Leitung',
  menu_level_1: 'menu level 1',
  menu_level_2: 'menu level 2',
  menu_level_3: 'menu level 3',
  item_disabled: 'item disabled',
  item_label: 'item label',
  item_caption: 'item caption',
  description: 'Beschreibung',
  other_cases: 'weitere Fälle',
  item_by_roles: 'item by roles',
  only_admin_can_see_this_item: 'Nur der Admin kann dieses Objekt sehen.',
  route_passengers: 'Route / Fahrgäste',
  error: 'Fehler',
  is: 'ist',
  on: 'an',
  on2: 'am',
  and: 'und',
  home: 'Home',
  settings: 'Einstellungen',
  logout: 'abmelden',
  resetSettings: 'Zurücksetzen',
  group: 'Gruppe',
  understood: 'verstanden',
  selectedDate: 'gewähltes Datum',
  dateAlert: 'Datum auf heute setzen',
  globalDateIgnoredTooltip:
    'Die aktuell angezeigte Liste wird ohne Berücksichtigung des Datums geladen. ' +
    'Das globale Datum wird hier nicht angewendet und kann daher nicht geändert werden. ' +
    'Deaktivieren Sie "Alle Touren zeigen", um wieder nach dem globalen Datum zu filtern.',
  refresh: {
    label: 'Neu laden',
    tourList: 'Tourenliste neu laden',
    studentList: 'Schülerliste neu laden',
    toursAndStudents: 'Touren und Schüler:innen neu laden',
    unavailable: 'Nicht verfügbar',
  },
  // ########################## //
  /*
  // Dictionary TICL - best practice
  // vocabulary which can be generalized should be at top as a single line
  // vocabulary which is specic to a item/person i.e. vehicle/student should be at bottom as a block
  //
  */
  // ########################## //
  salutation: 'Anrede',
  salutation_mr: 'Herr',
  salutation_mrs: 'Frau',
  salutation_none: '-',
  create_successful: 'Neuanlage erfolgreich!',
  update_successful: 'Aktualisierung erfolgreich!',
  delete_successful: 'Löschen erfolgreich!',
  deactivate_successful: 'Deaktivieren erfolgreich!',
  activate_successful: 'Aktivieren erfolgreich!',
  delete_not_successful: 'Löschen nicht erfolgreich!',
  update_not_successful: 'Aktualisierung nicht erfolgreich!',
  error_on_delete: 'Fehler beim Löschen',
  revert_successful: 'Zurücksetzen erfolgreich!',
  assigned_place: 'gewählter Ort',
  search_existing_place_or_geocode_new: 'suche bestehenden Ort oder geokodiere neuen Ort',
  geocode: 'Geokodieren',
  geocode_error: 'Angaben unvollständig - Geokodierung nicht möglich',
  create_new_place: 'Erstellen Sie einen Ort',
  publicTransportationStations: 'ÖPNV-Haltestellen',
  publicTransportationStation: 'ÖPNV-Haltestelle',
  mandatoryRoutingPoint: 'Zwangspunkt',
  id: 'ID',
  place_typ: 'Ortstyp',
  save: 'Speichern',
  change: 'Ändern',
  deactivate: 'Deaktivieren',
  save_place: 'speichere diesen Ort',
  select_this_place: 'Auswahl dieses ortes',
  more_places_in_place_picker: 'weitere Orte',
  gender: 'Geschlecht',
  gender_MALE: 'männlich',
  gender_FEMALE: 'weiblich',
  gender_DIVERS: 'divers',
  gender_UNDEFINED: '-',
  gender_null: '-',
  employeeRole_DRIVER: 'Fahrer:in',
  employeeRole_ESCORT: 'Begleitperson',
  employeeRoles_DRIVER_ESCORT: 'Fahrer:in, Begleitperson',
  email: 'E-Mail',
  phone: 'Telefon',
  mobileNumber: 'Mobilnummer',
  wheelchair: 'Rollstuhl',
  wheelchairs: 'Rollstühle',
  please_select: 'Bitte auswählen',
  required: 'benötigt',
  is_required: ' wird benötigt',
  name_required: 'Name wird benötigt',
  email_required: 'E-Mail wird benötigt',
  first_name_required: 'Vorname wird benötigt',
  last_name_required: 'Nachname wird benötigt',
  valid_from_required: 'Gültig ab Datum wird benötigt',
  valid_until_required: 'Gültig bis Datum wird benötigt',
  place_name_required: 'Adressname wird benötigt',
  street_required: 'Straße wird benötigt',
  house_number_required: 'Hausnummer wird benötigt',
  transportation_company_required: 'Verkehrsunternehmen wird benötigt',
  field_required: '{{field}} wird benötigt',
  only_number_required: '{{field}} muss eine Zahl sein',
  integer_required: '{{field}} muss eine Ganzzahl sein',
  positive_number_required: '{{field}} muss eine positive Zahl sein',
  post_code_required: 'PLZ wird benötigt',
  place_required: 'Ort wird benötigt',
  title_required: 'Titel wird benötigt',
  min_days_required: 'Mindestens ein Tag muss ausgewählt sein',
  validFromDateOutsideRange: 'Das Datum "Ab" muss ein Montag und gültig sein',
  validUntilDateOutsideRange: 'Das Datum "Bis" muss nach dem Datum "Ab" liegen und gültig sein',
  validUntilDateOutsideRangeValidFrom:
    'Das Datum "gültig bis" muss nach dem Datum "gültig ab" liegen.',
  update: 'Update',
  first_name: 'Vorname',
  last_name: 'Nachname',
  transportationDates: 'Beförderungszeitraum',
  transport_from: 'Beförderung von',
  transport_until: 'Beförderung bis',
  save_changes: 'Änderungen speichern',
  dashboard: 'Übersichtsseite',
  comments_and_documents: 'Kommentare und Dokumente',
  calendar_and_schedules: 'Kalender und Zeitplan',
  entries_over_time: 'Zeitlicher Verlauf',
  region: 'Bundesland',
  selectedShort: 'ausgewählt',
  selected: 'Einträge ausgewählt',
  unselectAll: 'Auswahl aufheben',
  onlySelected: 'Nur ausgewählte anzeigen',
  onlySelectedTooltip: 'Nicht ausgewählte Einträge in der Liste ausblenden',
  comment: 'Kommentar',
  mobilephone: 'Mobilnummer',
  contactperson: 'Ansprechperson',
  show_in_map: 'In Karte anzeigen',
  name: 'Name',
  vacations_and_deviations: 'Ferienkalender',
  deviations: 'Abweichungen',
  documents: 'Dokumente',
  map: 'Karte',
  prints: 'Ausdrucke',
  go: 'Start',
  cancel: 'Abbruch',
  unchanged: 'Unverändert',
  add_new_hour: 'Beförderungszeit erstellen',
  delete: 'Löschen',
  confirmationNeeded: 'Bestätigung erforderlich',
  delete_q: 'wirklich löschen?',
  delete_dialog: 'bestätige Löschen: ',
  delete_confirmation: 'Löschen bestätigen?',
  delete_dialog_of: 'Bestätigen Sie das Löschen folgender:',
  delete_assure: 'Wollen Sie folgende',
  deleted: 'gelöscht',
  numberHour: 'Beförderungszeit',
  endTime: 'Endzeit',
  startTime: 'Startzeit',
  error_saving: 'Fehler beim Speichern',
  error_infodialog: 'Es muss etwas schief gelaufen sein mit dem',
  online_help: 'online-Hilfe',
  sachbearbeiter: 'Sachbearbeiter:in',
  templatedDocumentType: 'Vorlagen Typ',
  templatedDocument: {
    generalTooltip: 'Pflichtfelder',
    optionalTooltip:
      'Zusätzliche Optionen: Darf nur bei Typ Genehmigungsschreiben geändert werden.',
    genehmigungsschreiben: 'Genehmigungsschreiben',
    changeTransportCompany: 'Verkehrsunternehmen ändern',
  },
  transportationModel: {
    singular: 'Standardwoche',
    plural: 'Standardwochen',
    edit: 'Standardwoche editieren',
    new: 'Standardwoche erstellen',
    transportationModelReadOnly:
      'Standardwoche kann nicht verändert werden, da es bereits Schüler:innen zugewiesen wurde.',
    transportationModelReadOnlyHint:
      'Standardwochen dienen als Vorlage für die Erstellung von Kalendereinträgen für Schüler:innen. Da sie flexibel in verschiedenen Zeiträumen (Vergangenheit oder Zukunft) angewendet werden können, würde eine nachträgliche Änderung bereits verknüpfter Standardwochen zu unerwarteten Ergebnissen führen. Bitte erstellen Sie stattdessen ein neue Standardwoche.',
    delete: 'Löschen einer Standardwoche',
    detail: 'Details der ausgewählten Standardwochen: ',
    name: 'Name der Standardwoche',
    studentListTooltip: 'Schüler:innen mit dieser Standardwoche am ausgewählten Datum',
    students: 'Schüler:innen',
    errorToursExist: 'Fehler beim Update der Standardwoche, da bereits Touren vorhanden sind.',
    errorStudentCalendarEventsExist:
      'Fehler beim Update der Standardwoche, da das Model bereits mit Schüler:innen verknüpft ist.',
    deleteError: 'Fehler beim Löschen einer Standardwoche',
    deleteErrorMessageSingular:
      'Die Standardwoche konnte aufgrund bestehender Verknüpfungen mit Schülern nicht gelöscht werden.',
    nameRequired: 'Name ist ein Pflichtfeld',
    validation: {
      toPlaceRequired: '{{day}} - {{hour}}: Typ Hinfahrt benötigt einen Zielort',
      fromPlaceRequired: '{{day}} - {{hour}}: Typ Rückfahrt benötigt einen Startort',
      transferToPlaceRequired: '{{day}} - {{hour}}: Typ Transferfahrt benötigt einen Zielort',
      transferFromPlaceRequired: '{{day}} - {{hour}}: Typ Transferfahrt benötigt einen Startort',
      unknownType: '{{day}} - {{hour}}: Unbekannter Schulstunden-Ortstyp: {{type}}',
    },
  },
  lot: {
    title: 'Lose',
    singular: 'Los',
    ignoreInCalculation: 'bei Berechn. ignorieren',
  },
  place: 'Ort',
  MONDAY: 'Montag',
  TUESDAY: 'Dienstag',
  WEDNESDAY: 'Mittwoch',
  THURSDAY: 'Donnerstag',
  FRIDAY: 'Freitag',
  SATURDAY: 'Samstag',
  SUNDAY: 'Sonntag',
  way_to: 'Hin',
  way_back: 'Rück',
  clock: 'Uhr',
  transportationPeriod: {
    singular: 'Beförderungsperiode',
    plural: 'Beförderungsperioden',
    new: 'Neue Beförderungsperiode anlegen',
    select: 'Beförderungsperiode auswählen',
    delete: 'Beförderungsperiode löschen',
    noneSelected: 'Keine Beförderungsperiode ausgewählt',
    dateRangeOverlap:
      'Der Zeitraum darf sich nicht mit einer bestehenden Beförderungsperiode überschneiden.',
    selectValidFrom: 'Gültig ab in das globale Datum eintragen.',
    selectValidUntil: 'Gültig bis in das globale Datum eintragen.',
    helpInfoText:
      'Die ausgewählte Beförderungsperiode bestimmt, welche Schüler:innen in den Listen angezeigt werden. Die Filterung erfolgt anhand der Angaben in den Feldern „Beförderung ab“ und „Beförderung bis“.',
  },
  validFrom: 'gültig ab',
  validUntil: 'gültig bis',
  from: 'Ab dem',
  toLaterThanFrom: 'Das Ende darf nicht vor dem Beginn liegen',
  create_tour: 'erstelle Tour',
  search: 'Suche...',
  new: 'Neu:',
  send_successful: 'Senden erfolgreich',
  send_failed: ' Senden fehlgeschlagen',
  send_delete_failed: 'Löschen fehlgeschlagen',
  created_at_date_time: 'Erstellzeitpunkt',
  imported: 'importiert',
  waiting_for_result: 'warten auf Ergebnis',
  customTransportationPlaceForToursWithoutStudentsSelect:
    'Beförderungspunkt für Sondertouren auswählen',
  customTargetTimeForToursWithoutStudentsSelect: 'Zielzeit für Sondertouren auswählen',
  targetTime: 'Zielzeit',
  targetTimeAtPlace: 'An/Ab Beförderungspunkt',
  dayOfWeek: {
    0: 'Sonntag',
    1: 'Montag',
    2: 'Dienstag',
    3: 'Mittwoch',
    4: 'Donnerstag',
    5: 'Freitag',
    6: 'Samstag',
  },
  check: {
    successful: 'erfolgreich abgeschlossen',
    last_run: 'letzte Prüfung',
    finished: 'abgeschlossen',
  },
  config: {
    config: 'Konfiguration',
    minutes: 'Minuten',
    minutesShort: 'Min.',
    inMinutes: 'in Minuten',
    timeMatrix_config: 'Ein- und Ausstiegszeiten',
    timeMatrix_config_entry: 'Konfiguration der Einstiegszeiten',
    timeMatrix_config_exit: 'Konfiguration der Ausstiegszeiten',
    timeMatrix_recalculation_info:
      'Änderungen an den Ein- und Ausstiegszeiten werden für bestehende Touren erst wirksam,' +
      ' nachdem die Touren über das Kontextmenü neu berechnet wurden.',
    default_more_than_8_students: 'Standardzeiten für mehr als 8 Fahrgäste',
    default_more_than_8_students_boarding_to: 'Einstiegszeit Hintour',
    default_more_than_8_students_disembarking_to: 'Ausstiegszeit Hintour',
    default_more_than_8_students_boarding_from: 'Einstiegszeit Rücktour',
    default_more_than_8_students_disembarking_from: 'Ausstiegszeit Rücktour',
    timeMatrix_config_seconds: 'Zeit in Sekunden',
    credit_limit_exceeded: 'Ihr Limit an Credits wurde überschritten.',
    credit_limit_status_description_month: 'Aktueller Status Ihrer Credits für diesen Monat',
    credit_limit_status_description_day: 'Aktueller Status Ihrer Credits für diesen Tag',
    credit_limit: 'Credits Limit',
    credits_exceeded: 'überzogene Credits',
    credits_used: 'verbrauchte Credits',
    credits_remaining: 'verbleibende Credits',
    bulk_update_value_timeMatrix: 'Alle Werte überschreiben',
  },
  provide_information: 'Pflichtangabe',
  cost_area: 'Kostenstelle',
  costcenter: 'Kostenbereich',
  cost_provider: 'Kostenträger',
  pedestrian: 'Fußgänger',
  addStudentsToExtraTour: 'Zu Extratour hinzufügen',
  addStudentsToExtraTourDialog: {
    popUpOpenTitle: 'Hinzufügen mehrerer Schüler:innen zu einer ausgewählten Extratour',
    firstStep: 'Datum für Extratour auswählen',
    firstStepInfo: 'Es werden alle Extratouren für das angegebene Datum geladen.',
    secondStep: 'Zielort auswählen',
    secondStepInfo: 'Bitte wählen sie einen Ort für die ausgewählten Schüler:innen aus: ',
    thirdStep: 'Schüler:innen zur ausgewählten Extratour hinzufügen',
    thirdStepInfo:
      'Um Schüler:innen hinzuzufügen, wählen sie bitte eine der nachfolgenden Extratouren aus: ',
    stepper: {
      openTempTourDialog: 'temporäre Touren zeigen',
      next: 'Nächster Schritt',
      back: 'Zurück',
    },
  },
  student: {
    singular: 'Schüler:in',
    singularAbbreviated: 'Pers.',
    plural: 'Schüler:innen',
    gender_MALE: 'Schüler',
    gender_FEMALE: 'Schülerin',
    gender_DIVERS: 'Schüler:in',
    new: 'Schüler:in erstellen',
    remove: 'Schüler entfernen',
    customTransportationPlace: 'Zusätzlicher Beförderungspunkt',
    customTransportationPlaceIsDefault: 'zusätzlicher Beförderungspunkt ist Standard',
    defaultTransportationPlace: 'Standard Beförderungspunkt',
    changingDefaultTransportationPlaceHint:
      'Geänderter Beförderungspunkt wird ab {{date}} in Kalenderevents eingetragen und Schüler:in aus allen Touren entfernt.',
    changingDefaultTransportationPlaceHintPlural:
      'Geänderter Beförderungspunkt wird ab {{date}} in Kalenderevents der Schüler:innen eingetragen und diese aus allen Touren entfernt.',
    changingCustomTransportationPlaceHint:
      'An dieser Stelle kann ein zusätzlicher Beförderungspunkt ausgewählt werden.',
    detail: 'Schüler',
    school_select: 'Auswahl aller Schüler:innen der Standardwoche: ',
    school_select_helper:
      'Selektieren Sie alle Schüler:innen dieser Standardwoche und speichern Sie',
    studentsOfTransportationModelId: 'Schüler:innen der Standardwoche mit der ID: ',
    studentsOfSchoolId: 'Schüler:innen der Schule mit der ID: ',
    studentsWithTransportationNeed: 'Schüler:innen mit Beförderungsbedarf',
    studentsFromTourSchoolId: 'Schüler:innen der Tour mit der ID: ',
    studentsFromSelectedTours: 'Schüler:innen der ausgewählten Touren',
    changes: {
      noCostAreaSelected: 'keine Kostenstelle',
      noCostCenterSelected: 'kein Kostenbereich',
      noCostProviderSelected: 'kein Kostenträger',
      noKreisSelected: 'kein Kreis',
      noJustificationSelected: 'kein Beförderungsgrund',
      noLotSelected: 'kein Los',
      noMobilitySelected: 'keine Mobilität angegeben',
      noSchoolSelected: 'keine Schule',
      noTransportationModelSelected: 'kein Standardwoche ausgewählt',
      editTransportationModelInList: 'Kann in der Schüler:innenliste bearbeitet werden',
      noUtilitySelected: 'keine Hilfsmittel',
    },
    mobilitySettings: 'Einstellungen Mobilität',
    changingSchoolHint:
      'Schüler:in wird ab {{date}} aus allen Touren entfernt und muss neu eingeplant werden',
    list: 'Liste aller Schüler:innen',
    add_tour: 'Schüler:innen zur Tour hinzufügen',
    add: 'Schüler:in hinzufügen',
    birthday: 'Geburtstag',
    parent: 'Erziehungsberechtigter',
    parents: 'Erziehungsberechtigte',
    first_name_parent_1: 'Vorname erster Erz.',
    last_name_parent_1: 'Nachname erster Erz.',
    first_name_parent_2: 'Vorname zweiter Erz.',
    last_name_parent_2: 'Nachname zweiter Erz.',
    wheelchairSitting: 'sitzend im Rollstuhl',
    mobility: 'Mobilität',
    utility: 'Hilfsmittel',
    justification: 'Beförderungsgrund',
    employeeNumber: 'Schüler:innen Nummer',
    schoolClass: 'Klasse',
    schultraeger: 'Schulträger',
    feststellungsbescheidValidUntil: 'Feststellungsbescheid gültig bis',
    foerderschwerpunkt: 'Förderschwerpunkt',
    instructions: 'Anweisungen Fahrplan',
    additionalInformation: 'Zusatzinformationen',
    escortInBus: 'Busbegleitung',
    escortInBusTooltip:
      'Bei der Busbegleitung wird genau ein Platz für alle Fahrgäste freigehalten. ',
    escortIndividual: 'Individualbegleitung',
    escortIndividualTooltip:
      'Für die Individualbegleitung wird jeweils ein Platz pro Fahrgast freigehalten. ',
    escortTooltipHint:
      'Die Begleitpersonen werden nicht automatisch zugewiesen, sondern müssen der Tour in einem zweiten Schritt manuell zugewiesen werden.',
    handToHand: 'Hand zu Hand',
    interkommLastenausgleich: 'Interkommunaler Lastenausgleich',
    interkommunalerLastenausgleichBafoeg: 'BAföG',
    interkommunalerLastenausgleichKindergarten: 'Kindergarten',
    interkommunalerLastenausgleichKreis: 'Kreis',
    tour_list: 'Touren der Schüler:innen',
    tourPlan_list: 'Planungen der Schüler:innen',
    transportationNeedFulfilled: 'Der Beförderungsbedarf ist gedeckt.',
    transportationNeedNotFulfilled: 'Der Beförderungsbedarf ist nicht (vollständig) gedeckt.',
    transportationNeedUnknown: 'Der Beförderungsbedarf ist nicht mehr aktuell.',
    transportationNeedFulfilled_description: 'Ist der Beförderungsbedarf gedeckt',
    transportationNeed: 'Beförderungsbedarf',
    deleteStudentSingular: 'Möchten Sie diese Schüler:in löschen?',
    deleteStudentPlural: 'Möchten Sie diese Schüler:innen löschen?',
    deleteErrorHintSingular:
      'Sollten keine Touren in der Zukunft bestehen, dann wird die Schüler:in ab morgigen Datum nicht mehr angezeigt.',
    deleteErrorHintPlural:
      'Sollten keine Touren in der Zukunft bestehen, dann werden die Schüler:innen ab morgigen Datum nicht mehr angezeigt',
    deleteStudentFailedSingular: 'Löschen fehlgeschlagen, da Schüler:in verplant',
    deleteStudentFailedPlural:
      'Löschen für folgende Schüler:innen fehlgeschlagen, da diese verplant sind: ',
    deleteErrorSingular: 'Fehler beim Löschen einer Schüler:in',
    deleteErrorPlural: 'Fehler beim Löschen der Schüler:innen',
    updateError: 'Fehler beim Aktualisieren der Schüler:in',
    updateErrorTourIdConflict:
      'Die Tour {{tourId}} steht im Zeitraum von {{from}} bis {{until}} im Konflikt mit den Änderungen. Bitte passen Sie die Tour an und versuchen Sie es erneut.',
    updateErrorTransportDate:
      'Der Beförderungszeitraum dieser Fahrgäste konnte nicht angepasst werden, da Touren betroffen sind. ' +
      'Sollen diese Touren angepasst werden und der neue Beförderungszeitraum gespeichert werden? Dafür werden ' +
      'die betreffenden Touren aufgesplittet und entsprechend des neuen Beförderungszeitraumes ' +
      'angepasst.',
    updateDateMustBeMonday: 'Bei Anpassung der Schule muss das Änderungsdatum ein Montag sein.',
    newDateMustBeMonday:
      'Das globale Datum muss bei der Erstellung auf einen Montag gesetzt werden',
    outsideSelectedTransportationPeriod:
      'Der Fahrgast wird in der ausgewählten Beförderungsperiode nicht befördert. Bitte wählen Sie eine andere oder keine Beförderungsperiode aus.',
    waitingForResult:
      'Die Anpassung wird durchgeführt. Das kann einige Minuten dauern. Bitte warten Sie und schließen Sie den Dialog nicht.',
    tour: {
      tours_of_selected_student: 'Anzeige für gewählte Schüler:innen',
      select_students_from_geocoded:
        'Die Tourenplanung konnte für die aktuell ausgewählten Schüler:innen nicht gestartet werden, da folgende Schüler:innen nicht eindeutig geokodiert sind:',
    },
    goToSchoolDetail: 'zur gewählten Schule',
    attributes: 'Attribute',
    editInfoAttributes: 'Attribute editieren',
    noAttributesSelected: 'keine Attribute ausgewählt.',
    dateMustBeMonday:
      'Das "gültig ab" Datum muss auf einen Montag gesetzt werden, wenn die Standardwoche oder die Schule angepasst wird',
    validFromWasUpdated: 'Das "gültig ab" Datum wurde aktualisiert.',
  },
  application: {
    titlePlural: 'Anträge',
  },
  studentApplication: {
    title: 'Schüler:innen Anträge',
    detail: 'Schüler:in Antrag',
    firstName: 'Vorname',
    lastName: 'Nachname',
    birthday: 'Geburtsdatum',
    emailAddress: 'E-Mail',
    phone: 'Telefonnummer',
    schoolClass: 'Klasse',
    school: 'Schule',
    parentLastName: 'Nachname des Erziehungsberechtigten',
    parentFirstName: 'Vorname des Erziehungsberechtigten',
    applicationForCurrentTransportationPeriod: 'Antrag für diese Beförderungsperiode',
    applicationForNextTransportationPeriod: 'Antrag für die nächste Beförderungsperiode',
    withUtilityDevice: 'mit Hilfsmittel',
    utility: 'Hilfsmittel',
    wheelchairTransportationRequired: 'Rollstuhlunterstützung',
    additionalNotes: 'weitere Kommentare',
    studentAddress: 'Adresse Schüler:in',
    parentAddress: 'Adresse Erziehungsberechtigte:r',
    editedByUserName: 'Benutzer:in',
    isApprovedByUser: 'Antrag wurde übernommen',
    deleteStudentApplications: 'Möchten Sie diese Anträge löschen?',
    comparison: {
      popUpOpenTitle: 'Prüfung und Übernahme',
      studentApplicationAttributes: 'Schüler:in Attribute aus Antrag',
      studentAttributes: 'Schüler:in Attribute im System',
      NO_MATCH: 'Es wurde kein Duplikat einer Schüler:in gefunden',
      SINGLE_MATCH: 'Es wurde ein Duplikat einer Schüler:in gefunden',
      MULTIPLE_MATCHES:
        'Es wurden mehrere Übereinstimmungen gefunden. Bitte überprüfen Sie die angezeigten Schüler:innen.',
      additionalAttributes: 'Wollen Sie weitere Attribute übernehmen? ',
      documents: 'Dokumente übernehmen',
      comments: 'Kommentare übernehmen',
      saveAttributes: 'ausgewählte Attribute übernehmen',
    },
    stepper: {
      studentStatus: 'Bitte wählen Sie ein Datum für die Duplikatprüfung aus:',
      chooseAttributes:
        'Bitte wählen Sie ein Attribut aus der jeweiligen Liste des Antrags oder der Schüler:in aus:',
      chooseAttributesWithoutDuplicate:
        'Bitte wählen Sie die Attribute für die Neuanlage einer Schüler:in aus:',
      next: 'nächster Schritt',
      back: 'zurück',
      error: 'Es ist ein Fehler beim Laden der Schüler:innen aufgetreten.',
      startDuplicateCheck: 'Überprüfung starten',
      chooseDateForCheck: 'Sie haben noch kein Datum für die Überprüfung ausgewählt.',
      noDuplicateFound:
        'Es wurde kein Duplikat festgestellt. Sie können nun einen neuen Schüler über die folgenden Schritte anlegen',
      createNewStudent: 'Möchten Sie einen neuen Schüler aus dem Antrag erstellen?',
      noAddressFound: 'Sie haben keine Adresse zum Geokodieren ausgewählt.',
      geocodeInfo:
        'Sie können die angegebene Adresse geokodieren. Ist die Schüler:in mit dem bisherigen Haltepunkt ' +
        'bereits in Touren verplant, wird ein zusätzlicher Haltepunkt bei der Schüler:in hinterlegt. Bei nicht eindeutiger Geokodierung ' +
        'wird kein Haltepunkt angelegt.',
      approveApplication: 'Antrag übernehmen',
      finalApprovalInfo:
        'Bei der Übernahme des Antrags wird ggf. eine Schüler:in im System aktualisiert bzw. neu angelegt. Die Änderung sind gültig ab dem ' +
        'von Ihnen ausgewählten Datum. Der Antrag wird nach der Übernahme als bearbeitet markiert.',
      ONE_foundDuplicates: 'gefundene Duplikate',
      TWO_approvalOfAttributes: 'Abgleich und Übernahme der Attribute',
      THREE_geocodingAddress: 'Geokodierung der Adresse',
      FOUR_finalApproval: 'finale Übernahme',
    },
  },
  school: {
    singular: 'Schule',
    id: 'Schul-ID',
    plural: 'Schulen',
    new: 'Schule erstellen',
    deleteSchoolSingular:
      'Möchten Sie diese Schule sowie verknüpfte Schüler:innen und Touren wirklich löschen?',
    lessons_show: 'Beförderungszeiten anzeigen',
    print_bill: 'Monatsabrechnung drucken',
    hours: 'Beförderungszeiten',
    maxWaitingTime: 'maximale Wartezeit',
    maxTransportationTime: 'maximale Beförderungszeit',
    minutesBeforeSchoolHour: 'Min. vor Schulstart/nach Schulende',
    config: 'Schulkonfiguration',
    color: 'Farbe',
    schoolAuthority: 'Schulträger',
    schoolDeletionEntities: {
      studentIdsOneSchool: 'Anzahl der Schüler:innen mit einer Schule: ',
      studentIdsTwoOrMoreSchool: 'Anzahl der Schüler:innen mit mehr als einer Schule: ',
      tourIds: 'Anzahl der Touren: ',
      plannedTourIds: 'Anzahl der geplanten Touren: ',
      specialTourIds: 'Anzahl der Sondertouren: ',
      extraTourIds: 'Anzahl der Extratouren: ',
      entityDocumentIds: 'Anzahl der Dokumente: ',
      transportFreeDaysIds: 'Anzahl der Ferientage: ',
      placeIds: 'Anzahl der Orte: ',
      amountTours: 'Anzahl der Touren: ',
      amountStudents: 'Anzahl der Schüler:innen: ',
      amountDocuments: 'Anzahl der Dokumente: ',
      infoText:
        'Bitte beachten Sie, dass alle Touren mit der ausgewählten Schule gelöscht werden. Schüler:innen mit mehr als einer Schule werden nicht gelöscht. ',
    },
    tour: {
      tours: 'Touren der Schule',
      tours_planned: 'Planungen der Schule',
      tours_of_selected_school: 'Anzeige für gewählte Schulen',
    },
    student: {
      students: 'Schüler der Schule',
    },
    schoolHour: {
      name: 'Beschreibung',
      grouping: 'Einrichtungsübergreifende Gruppierung',
      groupingHint:
        'Ermöglicht die gemeinsame Abholung naher Einrichtungen mit ähnlichen Beförderungszeiten.',
      time: 'Uhrzeit',
      readOnly:
        'Beförderungszeiten, die bereits verwendet werden, sind nicht editer- oder löschbar.',
      TO: 'Hinfahrt',
      FROM: 'Rückfahrt',
      TRANSFER: 'Transferfahrt',
      targetPlace: 'Zielort',
      startPlace: 'Startort',
      saveHint: 'Bitte auf Speichern klicken, um die Änderungen abzuschliessen',
    },
    error: {
      no_tours_planned: 'Es wurden keine Touren geplant.',
    },
  },
  schoolcenter: {
    singular: 'Schulzentrum',
    plural: 'Schulzentren',
    new: 'Schulzentrum erstellen',
  },
  address: {
    label: 'Adresse',
    street: 'Straße',
    house_number: 'Hausnummer',
    extension: 'Zusatz',
    district: 'Ortsteil',
    postal_code: 'PLZ',
    city: 'Ort',
    place_type: 'Ortstyp',
    copy_parent: 'Adresse auf Erziehungsberechtigte übertragen',
    geocoding: 'Geokodierung',
    geocoding_dialog: 'Adresse und Geokodierung',
    geocoding_result: 'Ergebnis',
    geocoding_results: 'Ergebnisse',
    geocoding_selected: 'ausgewählt',
    geocoding_state: 'geokodiert',
    geocoding_state_false: 'Adresse ist nicht geokodiert',
    geocoding_state_description: 'Konnte die Adresse geokodiert werden?',
    geocoding_save: 'Geokodierten Ort speichern',
    geocoding_error: 'Fehler beim Geokodieren einer Adresse',
    no_geocoding_result: 'keine Ergebnisse',
    mappedEntities: 'zugewiesene Objekte',
    coordinatesChanged: 'Koordinaten verändert',
    coordinatesUnchanged: 'Koordinaten unverändert',
  },
  jobs: {
    notfications: 'Benachrichtigungen',
    you_have: 'Sie haben ',
    unread_messages: ' Benachrichtigungen',
    mark_all_read: 'alle ausblenden',
    view_all: 'alle anzeigen',
    read_messages: ' Benachrichtigungen',
    personalizedNotifications: 'Nur eigene Benachrichtigungen anzeigen',
    unreadNotifications: 'Nur neue anzeigen',
    sent: 'Auftrag erfolgreich abgeschickt',
    error_sending: 'Fehler beim Senden des Auftrags',
    imported: 'importiert',
    issue: 'nicht importiert',
    refresh: 'Aktualisieren',
    errorIgnoreSchedule:
      'Es wurden Planungen ausgewählt, die ohne Berücksichtigung von Stundenplänen erstellt wurden.',
    notification: {
      period: 'Zeitraum: ',
    },
  },
  tours: {
    singular: 'Tour',
    plural: 'Touren',
    new: 'Tour erstellen',
    detail: 'Tour',
    calculate: 'Reihenfolge übernehmen',
    id: 'ID Tour-Zeitabschnitt',
    days: 'Tourtage',
    days_group: 'Teilen / In Tage aufsplitten',
    splitTourHelp:
      'Die Tour kann entweder zu dem gewählten Datum geteilt werden, oder in ihre Tourtage aufgeteilt werden. Dabei werden nicht ausgewählte Tourtage entfernt.',
    cloneAsPlannedTour: 'Erneut planen',
    cloneAsPlannedTourTooltip:
      'Erneut planen mit den selben Personen und Fahrtagen. Attribute werden dabei nicht kopiert. Die Tour wird als Planung erstellt.',
    new_day_group: 'Gruppe erstellen',
    to: 'nach',
    show_in_map: 'in Karte anzeigen',
    show_all_in_map: 'In Karte anzeigen',
    highlight_in_map: 'in Karte hervorheben',
    unhighlight_in_map: 'Hervorhebung in Karte entfernen',
    highlight_all_selected_in_map: 'Alle ausgewählten Touren in Karte hervorheben',
    generated: 'angelegt',
    not_generated: 'Es wurde keine ',
    tourFetchingType: 'Tour oder Planung',
    considerDailyValidity: 'Tour fährt am globalen Datum',
    occupiedDistance: 'Besetztkilometer',
    isPlannedTours: 'Planung',
    regular: 'Regulär',
    daySpecific: 'Tagesaktuell',
    amountOfStudentsInTour: 'Anzahl der Schüler:innen',
    studentNamesOfTour: 'Schüler:innen der Tour',
    studentNamesOfSelectedTours: 'Schüler:innen der ausgewählten Touren',
    daysFilter: 'Tourtage Filter',
    daysFilterEmpty: 'Wählen Sie Tage aus, um Touren nach Tagen zu filtern.',
    tourListWithoutDateConsideration: 'Alle Touren zeigen',
    globalDateIgnoredHint:
      '"Alle Touren anzeigen" ist aktiviert. Dadurch werden alle Touren unabhängig von ' +
      'ihrem Gültigkeitszeitraum angezeigt. Das global ausgewählte Datum wird in dieser ' +
      'Liste nicht berücksichtigt und ist deshalb in der Kopfzeile deaktiviert. ' +
      'Zeitabhängige Attribute werden am ersten Gültigkeitstag der jeweiligen Tour geladen.',
    globalDateIgnoredByFilterHint:
      'Durch die aktive Tourenauswahl werden alle Touren unabhängig von ihrem ' +
      'Gültigkeitszeitraum angezeigt. Das global ausgewählte Datum wird in dieser Liste ' +
      'nicht berücksichtigt und ist deshalb in der Kopfzeile deaktiviert. Zeitabhängige ' +
      'Attribute werden am ersten Gültigkeitstag der jeweiligen Tour geladen.',
    showExtendedAttributes: 'Tourenliste erweitern',
    extendedAttributesInfo: 'Anpassung der Tourenliste',
    extendedAttributesTooltip:
      'Aktiviert die Anzeige erweiterter Attribute in der Tourenliste. ' +
      'Dies umfasst zusätzliche Informationen ' +
      'wie benutzerdefinierte Tourenattribute, erweiterte Zeit- und Distanzberechnungen sowie ' +
      'weitere Toureigenschaften.',
    tourListWithoutDateConsiderationTooltip:
      'Deaktiviert die Filterung nach dem globalen Datum und zeigt alle Touren unabhängig ' +
      'von ihrem Gültigkeitszeitraum an. Zeitabhängige Attribute werden für jede Tour ' +
      'an ihrem ersten Gültigkeitstag geladen. ' +
      'Dies ist hilfreich, wenn Sie einen vollständigen Überblick über alle existierenden ' +
      'Touren benötigen, ohne Einschränkung durch das global ausgewählte Datum.',
    considerDailyValidityTooltip:
      'Berücksichtigt die tägliche Gültigkeit der Touren basierend' +
      ' auf dem aktuell ausgewählten globalen Datum.' +
      ' Wenn aktiviert, werden nur Touren angezeigt, die am entsprechenden Wochentag' +
      ' (z.B. Montag, Dienstag) geplant sind.',
    plannedWithCustomTransportationPlace: 'Mit zusätzlichem Beförderungspunkt geplant',
    overcrowded: 'überbelegt',
    totalStudents: 'Gesamtzahl der Schüler:innen',
    pendingNotification: {
      base: 'Die Touren werden berechnet',
    },
    minutesAroundSchool: 'Minuten vor Schulstart/nach Schulende',
    minutesAroundSchoolTOTour: 'Ankunft Minuten vor Schulstart',
    minutesAroundSchoolFROMTour: 'Abfahrt Minuten nach Schulende',
    optimizeOrder: 'Reihenfolge optimieren',
    optimizeOrderTooltip:
      'Bei aktivierter Option wird die Reihenfolge der Haltepunkte beim Hinzufügen von ' +
      'Schüler:innen automatisch optimiert.',
    tender: {
      title: 'Ausschreibungen',
      selectTourOrTourBundle: 'Auswahl von Touren oder Tour-Bündeln',
      parametersAndLayout: 'Parameter und Layout einstellen',
      parameters: 'Parametereinstellungen',
      firstPage: 'Erste Seite mit Leistungsbeschreibung',
      lastPage: 'Letzte Seite mit Leistungsangebot',
      tourServiceOfferText: 'Angebotstext',
      header: 'Titelblock',
      headerTitle: 'Leistungsbezeichnung für Ausgabe von Touren/Planungen',
      headerContentServiceName: 'Name der Leistung (bei Tour-Bündeln automatische Vergabe)',
      headerContentSchoolName: 'Schulen/Einrichtungen',
      headerContentLogo: 'Kundenlogo',
      tenderType: 'Ausschreibungstyp',
      headerValidity: 'Leistungszeitraum',
      serviceDescription: 'Leistungsbeschreibung',
      tourService: 'Fahrdienstleistung',
      tourServiceContentHeader: 'Header mit Wochentag, Zeit, Tournamen',
      tourServiceContentHeaderTourNumber: 'Header mit Tour-Nummer',
      tourServiceContentSchools: 'Adresse(n) der Schule(n)/Einrichtung(en)',
      tourServiceContentEscortPersonal: 'Anzahl Begleitpersonen und Rollstühle',
      tourServiceContentOccupiedValues: 'voraussichtliche Besetzt-Zeit und Besetzt-Km',
      stopsList: 'Auflistung der Haltepunkte',
      stopsListPostalCodeCity: 'Postleitzahl und Ort',
      stopsListCountStudentsAtStop: 'Anzahl Fahrgäste am Haltepunkt',
      stopsListPostalStreet: 'Straße des Haltepunktes',
      stopsListPostalStreetHouseNumber: 'Straße mit Hausnummer des Haltepunktes',
      stopsListSchoolClass: 'Schulklasse des Fahrgastes',
      stopsListYearOfBirth: 'Geburtsjahr des Fahrgastes',
      stopsListUtility: 'Hilfsmittel des Fahrgastes',
      stopsListMobility: 'Mobilität des Fahrgastes',
      stopsListShortNote: 'Hinweise zum Fahrgast',
      showServiceDescription: 'Leistungsbeschreibung anzeigen',
      showTourNumber: 'Tour-Nummer anzeigen',
      showStudentSchoolClass: 'Schulklasse anzeigen',
      showStudentHouseNumber: 'Straße mit Hausnummer anzeigen',
      showStudentYearOfBirth: 'Geburtsjahr anzeigen',
      showStudentUtility: 'Hilfsmittel anzeigen',
      showStudentMobility: 'Mobilität anzeigen',
      showStudentShortNote: 'Hinweise anzeigen',
      headerBidderSchools: 'Name der Schule(n)/Einrichtung(en)(automatische Anzeige)',
      bidderStandardText: 'Standard Angebotstext',
      offerDetailMatrix: 'Angebotsangaben',
      biddingFormDescription: 'Hinweistext an Bietende',
      showBiddingFormDescription: 'Hinweistext Bietende anzeigen',
      bidderInformation: 'Feld für Kontaktdaten Bietende',
      showBidderInformation: 'Feld für Kontaktdaten anzeigen',
      bidderInformationContent: 'Name, Straße, Hausnummer, PLZ, Ort, Telefon, E-Mail',
      bidderSignatureField: 'Unterschriftfeld für Bietende',
      bidderSignatureFieldContent: 'Ort, Datum, Unterschrift',
      saveAndSend: 'speichern und senden',
      defaultTimes: 'Standardzeiten',
      defaultTOArrivalTourTime: 'Standard Ankunftszeit Hintour',
      defaultFROMDepartureTourTime: 'Standard Abfahrtszeit Rücktour',
      defaultTimeExplanation:
        'Wenn eine Tour ohne Standardwoche geplant wurde, dann werden die Standardzeiten im Ausdruck ausgegeben. Bei Touren, die mit Standardwoche geplant wurden, erfolgt die Ausgabe der Ankunft-/Abfahrtzeiten aus den Touren.',
      showStudentHouseNumberInRange: 'Hausnummer in Nummernbereich anzeigen',
      showStudentName: 'Namen des Fahrgastes anzeigen',
      studentHouseNumberInRange: 'Hausnummer in Nummernbereich (Bsp: Maierstr. 7 = Maierstr 0-10)',
      studentName: 'Name des Fahrgastes',
      sameAsServiceDescription: 'identisch zum Titelblock der Leistungsbeschreibung',
    },
    errorNotification: {
      base: 'Fehler beim Anlegen von Touren. ',
      base_change: 'Fehler beim Ändern einer Tour',
      no_tours_planned: 'Es wurden keine Touren geplant.',
      no_transportationModel: 'Die betroffenen Fahrgäste haben keine Standardwoche.',
      no_weekday_with_demand: 'An keinem der ausgewählten Wochentage besteht Beförderungsbedarf.',
      tour_loading_error:
        'Fehler beim Laden der Tour: Das gewählte Datum liegt nicht im Gültigkeitszeitraum der Tour.',
      NO_PLANNED_TOUR_FOUND: 'Anhand dieser ID konnte keine Planungstour gefunden werden.',
      TOUR_VEHICLE_OVERCROWDED:
        'Das Fahrzeug der Planungstour ist überbelegt, daher kann die Umwandlung nicht erfolgen.',
      status: {
        'Internal Server Error': 'Ein interner Server-Fehler ist aufgetreten.',
        ALREADY_IN_TOUR: 'Der Fahrgast ist bereits dieser Tour zugewiesen.',
        STUDENT_ALREADY_IN_TOUR: 'Der Fahrgast ist bereits einer Tour zugewiesen.',
        LAST_STUDENT_IN_TOUR: 'Die Tour enthält nur noch diesen Fahrgast.',
        INSUFFICIENT_REGULAR_SEATS:
          'Das Fahrzeug hat nicht genügend reguläre Sitzplätze für den Fahrgast und ' +
          'erforderliche Begleitpersonen.',
        INSUFFICIENT_WHEELCHAIR_SEATS:
          'Das Fahrzeug hat nicht genügend Rollstuhlplätze für den Fahrgast.',
        MISSING_CALENDAR_EVENTS:
          'Der Fahrgast hat an mindestens einem Tourtag keine Kalendereinträge.',
        INCOMPATIBLE_SCHEDULE:
          'Die Beförderungszeiten der Events im Kalender des Fahrgastes sind nicht mit den ' +
          'Beförderungszeiten der Tour kompatibel.',
        NO_SEATS_AVAILABLE:
          'Es sind keine freien Plätze im Fahrzeug verfügbar. Bitte überprüfen Sie auch die Anzahl der freien Rollstuhlplätze.',
        NO_WEEKDAY_WITH_DEMAND: 'An keinem der ausgewählten Wochentage besteht Beförderungsbedarf.',
        TOO_MANY_VEHICLES_IN_FLEET: 'Es gibt zu viele Fahrzeuge in der Flotte.',
        NUMBER_OF_CUSTOM_PROFILES_EXCEEDED:
          'Die maximal zulässige Anzahl benutzerdefinierter Routing-Profile wurde überschritten.',
        UNEQUAL_TO_AND_FROM_TOURS:
          'Es gibt eine Unstimmigkeit bei der Anzahl der Hin- und Rücktouren.',
        NO_BOARDING_STOP_IN_TOUR: 'Es wurde kein Einstiegsstopp für die Tour gefunden.',
        NO_DISEMBARKING_STOP_IN_TOUR: 'Es wurde kein Ausstiegsstopp für die Tour gefunden.',
        GENERIC_ERROR: 'Ein allgemeiner Fehler ist aufgetreten.',
        ERROR: 'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Support.',
        TIME_LIMIT_EXCEEDED:
          'Die Tourenplanung bzw. das Routing konnte innerhalb von 60 Minuten nicht abgeschlossen werden.',
        REQUEST_QUEUE_ERROR: 'Ein Fehler in der Bearbeitung mehrerer Jobs ist aufgetreten.',
        NO_ROUTES_FOUND: 'Es konnten keine Routen berechnet werden.',
        NO_TOURS_FOUND: 'Es wurden keine Touren gefunden.',
        SECTIONS_EXCEED_NUMBER_OF_STOPS:
          'Die Anzahl der Segmente übersteigt die Anzahl der Stopps. Bitte wenden Sie sich an den Support.',
        GEOTRANSFORMATION_ERROR:
          'Bei der Geodatentransformation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.',
        MAX_DAYS_FOR_TOUR_INSTANCE_CALCULATION_EXCEEDED:
          'Die maximale Anzahl der Tage für die Berechnung tagesaktueller Touren wurde überschritten. ' +
          'Standardmäßig können maximal 31 Tage berechnet werden. Dieses Limit kann durch Terraplan angepasst werden.',
        STUDENT_ALREADY_IN_OVERLAPPING_TOUR:
          'Der Fahrgast ist für den ausgewählten Zeitraum bereits in einer Tour verplant.',
        INCOMPATIBLE_TRANSPORTATION_PERIOD:
          'Das ausgewählte Datum liegt außerhalb des Beförderungszeitraums des Fahrgastes.',
        NO_ORIGINAL_TOUR_IN_HOLDER: 'Die ausgewählte Tour ist momentan nicht verfügbar.',
        CREDIT_LIMIT_EXCEEDED:
          'Das Credit-Limit wurde überschritten. Bitte wenden Sie sich an den Support.',
        MAX_TIME_IN_VEHICLE_CONSTRAINT:
          'Sie können den Fahrgast nicht hinzufügen, da sonst die maximale ' +
          'Beförderungszeit überschritten wird. Hinweis: Sie können die maximale ' +
          'Beförderungszeit in der Schule bearbeiten und den Fahrgast anschließend in die Tour eintragen.',
        TIME_WINDOW_CONSTRAINT:
          'Der Fahrgast kann nicht hinzugefügt werden, weil ein vorgegebenes Zeitfenster ' +
          'nicht eingehalten werden kann. Prüfen Sie insbesondere die maximale Wartezeit der ' +
          'betroffenen Schule sowie die Abhol- und Einsatzzeiten.',
        SCHEDULE_NOT_SUITABLE:
          'Bitte überprüfen Sie den Kalender des Fahrgastes. Für mindestens einen Tourtag wurden keine passenden Kalendereinträge gefunden.',
        STUDENT_DOES_NOT_FIT:
          'Der Fahrgast kann aufgrund der Fahrzeugkapazität, des Tourtyps, der Gruppierung ' +
          'oder der angegebenen Beförderungszeiten nicht hinzugefügt werden.',
        NO_SCHEDULE:
          'Bitte überprüfen Sie den Kalender des Fahrgastes. Es konnten keine Events ' +
          'zum Zeitpunkt der Änderung gefunden werden.',
        VEHICLE_TYPE_NOT_DEFINED:
          'Bitte überprüfen Sie, ob alle verplanten Fahrzeuge einen Fahrzeugtyp' +
          ' zugewiesen haben.',
        TOUR_CLASS_COST_FEE_NOT_DEFINED:
          'Bitte überprüfen Sie, ob in der Zeitkategorien-Preismatrix für alle verwendeten ' +
          'Fahrzeugtypen und Kostenarten Preise hinterlegt sind.',
        TRANSPORTATION_COMPANY_NOT_DEFINED:
          'Der Preisblatt-Export wurde abgebrochen, weil mindestens einem tatsächlich ' +
          'eingesetzten Fahrzeug kein Verkehrsunternehmen zugeordnet ist. Bitte überprüfen Sie ' +
          'die Fahrzeug-Stammdaten.',
      },
      overlappingToursInfo:
        'Fahrgast {{studentId}} ist bereits {{count}} Tour(en) am {{date}} zugewiesen:',
      viewTour: 'Tour anzeigen',
      details: {
        studentId: {
          singular: 'Fahrgast-ID',
          plural: 'Fahrgast-IDs',
        },
        tourId: 'Tour-ID',
        validAt: 'Hinzugefügt am',
        transportFrom: 'Beförderung ab',
        transportUntil: 'Beförderung bis',
        transportationPeriodIncompatibility: 'Außerhalb des Beförderungszeitraums',
        incompatibleDay: 'Inkompatibler Tag',
        tourGroupings: 'Gruppierungsnummer der Beförderungszeit am Tourtag',
        studentGroupings: 'Gruppierungsnummer der Beförderungszeit des Events',
        availableSeats: 'Verfügbare Sitzplätze',
        requiredSeats: 'Benötigte Sitzplätze',
        availableWheelchairSeats: 'Verfügbare Rollstuhlplätze',
        requiredWheelchairSeats: 'Benötigte Rollstuhlplätze',
        needsWheelchair: 'Rollstuhlplatz benötigt',
        needsIndividualEscort: 'Einzelbegleitung benötigt',
        needsBusEscort: 'Busbegleitung benötigt',
      },
      transportationPeriodCompatibilityStatus: {
        COMPATIBLE: 'Innerhalb des Beförderungszeitraums',
        BEFORE_TRANSPORT_FROM: 'Vor Beförderungsbeginn',
        AFTER_TRANSPORT_UNTIL: 'Nach Beförderungsende',
      },
    },
    route_passengers: 'Route und Stopps',
    overview: 'Übersicht',
    edit: 'Tour bearbeiten',
    validityOutsideGlobalDate:
      'Das gewählte Anzeigedatum liegt außerhalb des Gültigkeitszeitraums der Tour: Eine tagesaktuelle Anzeige der Attribute ist nicht möglich.',
    add_student: 'Schüler:in hinzufügen',
    add_mandatory_routing_point: 'Zwangspunkt hinzufügen',
    addStudentFiltered:
      'Schüler:innen hinzufügen (Gefilterte Liste: Es werden nur passende Schüler:innen angezeigt)',
    studentSwitchFilter: 'Geeignete Personen filtern',
    addStudentWithPlaceInfo:
      'Der ausgewählte Ort wird beim Schüler als Abhol- bzw. Abfahrtsort in der Extratour hinterlegt und die Tour wird neu berechnet.',
    addMandatoryRoutingPointPlaceInfo:
      'Der ausgewählte Ort wird als Zwangspunkt in der bestehenden Tour eingetragen und die Tour wird neu berechnet.',
    tourType: {
      type: 'Hin-/Rückfahrt',
      TO: 'Hinfahrt',
      FROM: 'Rückfahrt',
      TRANSFER: 'Transfer',
      EXTRA: 'Extratour',
      TRANS_MODEL_TO_DEVIATION: 'Abweichung Hinfahrt',
      TRANS_MODEL_FROM_DEVIATION: 'Abweichung Rückfahrt',
      DEVIATION: 'Abwesenheit',
      VACATION: 'Ferien',
      OTHER: '...',
      abbreviation: {
        TO: 'H',
        FROM: 'R',
        TRANSFER: 'T',
        OTHER: 'O',
      },
    },
    tourReason: {
      reason: 'Grund',
      TRANSPORTATION_MODEL: 'Standardwoche',
      DEVIATION: 'Abweichung',
      EXTRA_TOUR: 'Extratour',
      SPECIAL_TOUR: 'Sondertour',
      IGNORE_SCHEDULE: 'Standardwoche ignoriert',
    },
    tourInMap: {
      id: 'Tour-ID',
      attributes: 'Attribute',
      type: 'Tour-Typ',
      empty_segment: 'Leerfahrt',
      normal_segment: 'Toursegment',
      departure: 'Abfahrtsort',
      arrival: 'Ankunftsort',
      time: 'Fahrtdauer',
      distance: 'Distanz',
      meter: 'Meter',
      tourId: 'Tour-ID',
      allStudents: 'alle Studenten',
      allSchools: 'alle Schulen',
    },
    plan: {
      plural: 'Planungen',
      singular: 'Planung',
      detail: 'Planung',
      dialog: 'Touren planen',
      dialogSchools: 'Sondertouren planen',
      dialogFROMTours: 'Rücktouren planen',
      deletedPlural: 'Planungen gelöscht',
      customTransportationPlaceHint:
        'Berücksichtige für die Tourenplanung entweder die Adresse oder den zusätzlichen Beförderungspunkt des Fahrgastes. Falls kein zusätzlicher Beförderungspunkt hinterlegt ist, wird die Wohnaschrift verwendet.',
      tourType: 'Tour-Art',
      algorithm: 'Algorithmus',
      vehicleType: 'Fahrzeuge',
      to: 'Hintour',
      from: 'Rücktour',
      transfer: 'Transfer',
      fromTransportationPlace: 'Ziel ist Schule',
      toTransportationPlace: 'Ziel ist gewählter Ort',
      algorithmSame: 'wie in Hintour',
      algorithmGroupPriority: 'Schülergruppen zusammenhalten',
      algorithmScheduleAware: 'Stundenpläne berücksichtigen',
      algorithmIgnoreSchedule: 'Stundenpläne ignorieren',
      algorithmOptimal: 'optimal',
      vehicleTypes: {
        AVAILABLE: 'Verfügbare Flotte',
        IMPLICIT: 'Virtuelle Flotte',
        EXPLICIT: 'Fahrzeuge auswählen',
      },
      ignoreVehiclePlaces: 'Fahrzeugstandort ignorieren',
      planning: 'Planung starten',
      select_only_from_tours: 'Bitte wählen Sie nur Hintouren aus.',
      errorDateRange: 'Bitte geben Sie einen gültigen Zeitraum für die Tourenplanung an.',
      transform: 'Planung als Touren übernehmen',
      vehiclePlaceType: 'Fahrzeugstandort-Typ',
      vehiclePlaceTypes: {
        DEFAULT: 'Fahrzeugstandort',
        EXPLICIT: 'Gewählter Ort',
        TRANSPORTATION_COMPANY: 'Betriebshof',
      },
      scheduleAwareHint:
        'Name, Tourtage, Gültigkeit und Fahrgäste werden aus den gewählten Hintouren übernommen',
      hintCalenderWeek:
        'Die Touren werden auf Grundlage der Kalendereinträge in KW {{weekNumber}} geplant.',
      hintCalenderWeekExplanation:
        'Planungsgrundlage ist die erste Woche des gewählten Zeitraums.' +
        'Die Kalendereinträge der ersten Woche werden verwendet, um die Touren zu planen.' +
        'Von der ersten Woche abweichende Kalendereinträge der folgenden Wochen werden an dieser Stelle nicht berücksichtigt.',
      reserveSeatForBusEscort: '1 Platz für Busbegleitung freihalten',
      calculationMethod: 'Optimierung nach',
      shortestTime: 'Zeit',
      shortestDistance: 'Strecke',
      planFromTours: 'Rücktouren automatisch planen',
      tourPlanningWizard: 'Rücktouren manuell planen',
    },
    transform: {
      title: 'Ergebnis Touren-Übernahme',
    },
    no_boarding: 'Kein Einstieg an diesem Stop',
    no_disembarking: 'Kein Ausstieg an diesem Stop',
    duration: 'Gesamtfahrzeit: ',
    students_do_boarding: 'Schüler:innen steigen hier ein',
    students_do_disembarking: 'Schüler:innen steigen hier aus',
    students_unassigned: 'Schüler:innen konnten nicht eingeplant werden',
    unassignedReasonUnknown: 'Unbekannter Grund (Code: {{code}})',
    unassignedType: {
      UNKNOWN: 'unbekannter Grund',
      SKILL_CONSTRAINT: 'Fahrzeuge erfüllen Anforderungen nicht',
      TIME_WINDOW_CONSTRAINT: 'Zeitfenster für die geplante Tour reicht nicht aus. ',
      CAPACITY_CONSTRAINT: 'Zu wenig Fahrzeuge/Sitzplätze. ',
      MAX_JOB_CONSTRAINT: 'Zu wenig Fahrzeuge/Sitzplätze. ',
      MAX_DISTANCE_CONSTRAINT: 'Distanz ist zu lang. ',
      NO_TRANSPORTATION_NEED: 'Beförderungsbedarf liegt nicht im Zeitraum.',
      NO_REASON_FOUND: 'unbekannter Grund ',
      REACHABLE_CONSTRAINT: 'Ort kann aufgrund der Verkehrsbedingungen nicht erreicht werden. ',
      SHIFT_TIME_CONSTRAINT: 'Maximale Fahrer-Arbeitszeit ist überschritten. ',
      RELATION_CONSTRAINT:
        'Beförderung ist an eine andere Beförderung gekoppelt. ' +
        'Vorgegebene gemeinsame Zuordnung bzw. Reihenfolge konnte nicht eingehalten werden',
      ALLOWED_VEHICLE_CONSTRAINT: 'Zulässige Anzahl an Fahrzeugen ist überschritten. ',
      MAX_TIME_IN_VEHICLE_CONSTRAINT: 'Maximale Beförderungszeit überschritten.',
      BREAK_NOT_REQUIRED: 'Fahrer:in benötigt keine Pause. ',
      DISALLOWED_VEHICLE_CONSTRAINT:
        'Verfügbaren Fahrzeuge sind für diesen Auftrag ausgeschlossen. ',
      MAX_DRIVE_TIME_CONSTRAINT: 'Maximal zulässige Fahrzeit wurde überschritten. ',
      MAX_ACTIVITY_CONSTRAINT: 'Maximal zulässige Anzahl an Aktivitäten würde überschritten. ',
      GROUP_RELATION_CONSTRAINT: 'Beförderungsgruppe passt nicht zu den Vorgaben',
      DRIVING_TIME_BREAK_CONSTRAINT:
        'Vorgeschriebene Fahrzeitpausen können nicht eingeplant werden. ',
      LOCATION_NOT_ACCESSIBLE_CONSTRAINT:
        'Ort ist über das Straßennetz nicht für alle Fahrzeuge erreichbar. ',
      LOCATION_ISOLATED_CONSTRAINT:
        'Ort ist isoliert und über das Straßennetz mit keinem anderen Ort verbunden. ',
    },
    tourDetail: {
      studentCount: 'Anzahl Schüler:innen',
      stopsCount: 'Anzahl Haltepunkte',
      wheelchairCount: 'Anzahl Rohlstuhlfahrer:innen',
      freeSeats: 'freie Plätze im Fahrzeug',
      freeWheelchairSeats: 'davon freie Rollstuhlplätze im Fahrzeug',
      individualEscortCount: 'Anzahl Individualbegleitung',
      studentWithWheelchairCount: 'Anzahl Rollstuhlfahrer:innen',
      utilities: 'Auflistung Hilfsmittel',
      routingMethod: 'Routing-Methode',
      plannedWithCustomTransportationPlace: 'mit zusätzlichem Beförderungspunkt geplant',
      duration: 'Dauer',
      costsPlannedState: 'Preise',
      costs: 'Preise',
      costHistory: 'Historie Preise',
      distance: 'Strecke',
      number: 'Tour-Nummer',
      numberHint: 'Die Tour-Nummer kann bei Planungen nicht gesetzt werden',
      abbreviation: 'Tour-Kürzel',
      validityPeriod: 'Gültigkeit',
      virtualVehicle: 'virtuelles Fahrzeug',
      virtualDriver: 'virtuelle Fahrer:in',
      noDriver: 'keine Fahrer:in',
      missing: 'fehlt in Tour am',
      additional: 'fährt mit in Tour am',
      noDeviation: 'keine Abweichungen vorhanden',
      delete_tour: 'Möchten Sie diese {{tour}} löschen?',
      emptySections: 'Leerfahrten',
      emptySectionsVirtualVehicleHint:
        'Leerfahrten können bei Touren mit virtuellem Fahrzeug nicht zugewiesen werden.',
      emptyDistancePercentage: 'Anteil-Leerkilometer',
      timeline: 'Zeitabschnitte Tour-Nummer',
      noTimeline: 'keine Tour-Nummer gesetzt',
      km: {
        occupiedKm: 'Besetztkilometer',
        emptyKmTO: 'Leerkilometer Hin',
        emptyKmFROM: 'Leerkilometer Rück',
        emptyKmSum: 'Leerkilometer Summe',
        kmSum: 'Gesamtkilometer (Besetzt + Leer)',
        placeEmptyTO: 'Startort Leerfahrt Hin',
        placeEmptyFROM: 'Zielort Leerfahrt Rück',
        overriddenOccupiedDistance: 'APV-Km',
      },
      time: {
        occupiedTime: 'Besetztminuten',
        emptyTimeTO: 'Leerfahrtminuten Hin',
        emptyTimeFROM: 'Leerfahrtminuten Rück',
        emptyTimeSum: 'Leerfahrtminuten Summe',
        boardingSum: 'Einstiegsdauer Summe aller Haltepunkte',
        disembarkingSum: 'Ausstiegsdauer Summe aller Haltepunkte',
        waitingTime: 'Wartezeit',
        timeBeforeSchoolStart: 'Ankunft vor Schulbeginn',
        timeAfterSchoolEnd: 'Abfahrt nach Schulende',
        timeSum: 'Gesamtdauer (Besetzt + Leer)',
        additionDriverWorkingTime: 'Zuschlag Arbeitszeit Fahrer:in',
        driverWorkingTimeSum: 'Lohnzeit Fahrer:in Summe',
      },
      price: {
        occupiedCostPerKm: 'Preis je Besetztkilometer',
        emptyCostPerKm: 'Preis je Leerkilometer',
        costFlatRate: 'Pauschale',
        costAddition: 'Zuschlag',
        occupiedCostSum: 'Besetztkilometer Preis',
        emptyCostSum: 'Leerkilometer Preis',
        costSum: 'Gesamtpreis',
      },
      utilityOption: {
        utility_e_wheelchair_sitting: 'E-Rollstuhl sitzend',
        utility_e_wheelchair_movable: 'E-Rollstuhl Umsetzer',
        utility_wheelchair_foldable: 'Faltrollstuhl',
        utility_wheelchair_fixed: 'fester Rollstuhl',
        utility_child_seat: 'Kindersitz',
        utility_walker: 'Rollator',
        utility_seat_shell: 'Sitzschale',
        utility_other: 'Sonstiges',
        utility_wheelchair_fixed_knot: 'Rollstuhl (mit Kraftknoten)',
        utility_child_seat_fixed: 'Kindersitz 3-Punkt-Gurt',
        utility_seat_raised: 'Sitzerhöhung',
      },
      changedAttributes: {
        driver: 'Wechsel der Fahrer:in im Gültigkeitszeitraum anzeigen',
        escort: 'Wechsel der Begeleitperson im Gültigkeitszeitraum anzeigen',
        vehicle: 'Fahrzeugänderung im Gültigkeitszeitraum anzeigen',
        cost: 'Kostenänderung im Gültigkeitszeitraum anzeigen',
        emptySection: 'Änderungen der Leerfahrten im Gültigkeitszeitraum anzeigen',
        changedVehicleHint:
          'Bei Änderung des Fahrzeugs werden die Leerfahrten ab dem gewählten Datum aktualisiert',
        driverHistory: 'Historie Fahrer:innen',
        vehicleHistory: 'Historie Fahrzeuge',
        emptySectionHistory: 'Historie Leerfahrten',
      },
      escortAssignment: {
        history: 'Historie Begleitpersonen',
        noEmployee: 'keine Begleitperson',
        title: 'Begleitpersonen',
        deleteDialogTitle: 'Wollen Sie diesen Eintrag wirklich löschen?',
      },
    },
    list: {
      selected_tours: 'Anzeige gewählter Touren',
      delete_tours: 'Möchten Sie diese {{tour}} löschen?',
    },
    tempTour: {
      seeGeneratedTempTours:
        'Bitte kontrollieren Sie die temporären Touren mit den Anpassungen, die Sie an der Tour-ID {{id}} vorgenommen haben',
      originalTour: 'Bisherige Tour',
      allTempTour: 'Neue Touren',
      noTempTour: 'Es werden keine temporären Touren generiert. Bitte versuchen Sie es erneut.',
      selectOneTempTour: 'Bitte wählen Sie eine temporäre Tour aus',
      showAllToursInMap: 'Alle Touren in Karte anzeigen',
      saveAllTempTours: 'Alle Touren speichern',
      discardAllTempTours: 'Alle Touren verwerfen',
      stop: 'Stopps',
      tempTour: 'Temporäre Tour',
    },
    rerouted_CURRENT: 'Touren mit bestehender Optimierung neu berechnet',
    rerouted_SHORTEST_PATH: 'Touren nach kürzester Strecke neu berechnet',
    rerouted_SHORTEST_TIME: 'Touren nach kürzester Zeit neu berechnet',
    dateValidation: {
      dateOutsideTourRange:
        'Das ausgewählte Datum liegt nicht im Gültigkeitszeitraum der Tour. Wenn sie Änderungen an der' +
        ' Tour vornehmen wollen, dann wählen Sie ein Datum innerhalb des Gültigkeitszeitraums.',
    },
  },
  tourPlan: {
    name: 'Tourplan',
  },
  tourBundle: {
    bundleName: 'Tour-Bündel',
    bundleCreate: 'Tour-Bündel erstellen',
    bundleEdit: 'Tour-Bündel editieren',
    bundleAdd: 'zu Tour-Bündel hinzufügen',
    description: 'Beschreibung',
    color: 'Farbe',
    singular: 'Tour-Bündel',
    plural: 'Tour-Bündel',
    new: 'Neues Tour-Bündel',
    detail: 'Tour-Bündel',
    list: 'Liste aller Tour-Bündel',
    deleteTourBundles: 'Tour-Bündel löschen',
    deleteConfirm: 'Möchten Sie dieses Tour-Bündel löschen?',
    deleteConfirmPlural: 'Möchten Sie diese Tour-Bündel löschen?',
    deleteSuccess: 'Tour-Bündel erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen des Tour-Bündels',
    createSuccess: 'Tourbündel erfolgreich erstellt',
    createError: 'Fehler beim Erstellen des Tour-Bündels',
    updateSuccess: 'Tourbündel erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren des Tour-Bündels',
    tours: 'Touren',
    addTours: 'Touren hinzufügen',
    removeTours: 'Touren entfernen',
    noTours: 'Keine Touren im Bündel',
  },
  file: {
    name: 'Dateiname',
    format: 'Dateiformat',
    print_request_successful: 'Ihre Druckanfrage war erfolgreich',
    pick_date_range: 'Zeitraum auswählen',
    pdf: {
      create: 'PDF-Datei erstellen',
      delete: 'PDF-Datei löschen',
    },
    excel: {
      create: 'Excel-Datei erstellen',
      delete: 'Excel-Datei löschen',
    },
  },
  our_calendar: {
    today: 'Heute',
    event: 'Kalenderevent',
    add_event: 'Eintrag hinzufügen',
    edit_event: 'bearbeiten',
    event_type: 'Event-Typ',
    VACATION: 'schulfreie Tage',
    TRANSPORTATION_MODEL: 'Standardwoche',
    TRANSPORTATION_MODEL_DEVIATION: 'Abweichung von Standardwoche',
    TRANS_SCHEDULE: 'Fahrt',
    TRANS_MODEL_TO: 'Fahrt',
    TRANS_MODEL_FROM: 'Fahrt',
    TRANS_MODEL_TRANSFER: 'Transferfahrt',
    DEVIATION: 'Abweichung',
    TRANS_DEVIATION: 'Abweichung Fahrt',
    TRANS_EXTRA_TOUR_TO: 'Extratour (Zielzeit wählbar)',
    TRANS_EXTRA_TOUR_FROM: 'Extratour (Startzeit wählbar)',
    TRANS_MODEL_TO_DEVIATION: 'Fahrt',
    TRANS_MODEL_FROM_DEVIATION: 'Fahrt',
    TRANS_MODEL_TRANSFER_DEVIATION: 'Fahrt',
    TRANS_MODEL_TO_MANUAL: 'Hinfahrt',
    TRANS_MODEL_FROM_MANUAL: 'Rückfahrt',
    TRANS_MODEL_TRANSFER_MANUAL: 'Transferfahrt',
    no_transport: 'ganztägig keine Beförderung',
    departure_trans_schedule_from: 'Rück:',
    departure_trans_schedule_transfer: 'Transfer:',
    arrival_trans_schedule_to: 'Hin:',
    place: 'Ort: ',
    WEEKLY: 'wöchentlich',
    TWO_WEEKLY: 'jede zweite Woche',
    NONE: '',
    create_event_success: 'Eintrag erfolgreich angelegt',
    unavailability: {
      calendar: 'Abwesenheitskalender',
      add_event: 'Abwesenheitseintrag hinzufügen',
      select: 'Abwesenheitsanlass auswählen',
    },
    recurrence_end_day: 'Serienende',
    recurrence: 'Serienhäufigkeit',
    title: 'Titel',
    start_date: 'Start',
    end_date: 'Ende',
    start_time: 'Abfahrtszeit',
    end_time: 'Ankunftszeit',
    deactivate_single_event: 'Einzelevent deaktivieren',
    deactivate_series: 'Serie deaktivieren',
    make_event_adjustment: 'Abweichung',
    year: 'Jahr',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    agenda: 'Agenda',
    undoDeviation: 'Event wiederherstellen',
    helpTextExtraEventRecurrence:
      'Die Extratour ist für einen Tourtag und bis zum Serienende gültig.',
    transportationModelInformation: 'Dieses Event basiert auf der Standardwoche ',
    confirm_recurrenceEnd_change: 'Änderung des Serienendes bestätigen',
    confirm_recurrenceEnd_change_message:
      'Wenn Sie das Serienende ändern, werden alle Touren ab dem Änderungsdatum angepasst. ' +
      'Der Schüler wird am Wochentag der Änderung nicht mehr befördert. Sind Sie sicher,' +
      ' dass Sie das Serienende ändern möchten?',
    recurrenceEnd_date_changed: 'Das Serienende wurde geändert.',
    recurrenceEnd_date_change_cancelled: 'Die Änderung des Serienendes wurde abgebrochen.',
  },
  transportationCompany: {
    singular: 'Verkehrsunternehmen',
    plural: 'Verkehrsunternehmen',
    new: 'Verkehrsunternehmen erstellen',
    contactPerson: 'Ansprechpartner:in',
    selectAutomatically: 'Automatisch auswählen',
    virtual: 'Virtuelle Flotte',
    tour: {
      tours: 'Touren des Verkehrsunternehmens',
      tours_planned: 'Planungen des Verkehrsunternehmens',
      tours_of_selected_transportation_company: 'Anzeige für gewählte Verkehrsunternehmen',
    },
  },
  tourClassVehicleMatrix: {
    tabTitle: 'Zeitkategorien - Preismatrix',
    title: 'P2/P3 - Preismatrix für Fahrleistung und Personal pro Tour',
    singular: 'Matrix',
    plural: 'Matrizen',
    new: 'Neuen Eintrag erstellen',
    edit: 'Eintrag bearbeiten',
    selectVehicleType: 'Bitte wählen Sie einen Fahrzeugtyp aus',
    addedToList: 'Matrix zur Liste hinzugefügt',
    noData: 'Keine Einträge vorhanden',
    allSavedSuccess: '{{count}} Einträge erfolgreich gespeichert',
    unsavedEntries: 'Nicht gespeicherte Einträge',
    saveError: 'Fehler beim Speichern der Matrizen',
    removedFromList: 'Matrix aus der Liste entfernt',
    deleteConfirm: 'Möchten Sie diese Matrix wirklich löschen?',
    deleteSuccess: 'Matrix erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen der Matrix',
    updateSuccess: 'Matrix erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Matrix',
    vehicleType: 'Fahrzeugtyp',
    matrixType: 'Matrix-Typ',
    tourClass: 'Zeitkategorie',
    costFee: 'Preis',
    actions: 'Aktionen',
    addToList: 'Zur Liste hinzufügen',
    saveAll: 'Alle nicht gespeicherten Einträge speichern',
    unsavedChanges: 'Ungespeicherte Änderungen',
    localList: 'Lokale Liste',
    existingMatrix: 'Bestehende Matrix',
    costType: 'Kostentyp',
    types: {
      DRIVING_PERFORMANCE: 'Fahrleistung',
      DRIVER: 'Fahrer',
      ESCORT: 'Begleitung',
    },
    infoDescription:
      'Hier können Sie eine Preismatrix definieren, die Preise für verschiedene Zeitkategorien speichert. ' +
      'Jede Matrix definiert Tarife für eine bestimmte Kombination aus Fahrzeugtyp und Kostenart ' +
      '(Fahrleistung, Fahrer oder Begleitung). Die Preise sind nach Zeitkategorie indexiert,' +
      ' wobei Zeitkategorien verschiedene Dauerbereiche von Touren repräsentieren. Sie können für' +
      ' jede Kombination aus Kostentyp und Fahrzeugtyp einen Eintrag erstellen.',
    noTourClassTimesWarning:
      'Legen sie zuerst Zeitkategorien an, bevor Sie Einträge für die Matrix erstellen.',
  },
  tourClassTimes: {
    title: 'Definition der Zeitkategorien',
    durationMin: 'Dauer Min (Minuten)',
    durationMax: 'Dauer Max (Minuten)',
    tourClass: 'Zeitkategorie',
    saveTimes: 'Zeitkategorien speichern',
    createTimes: 'Neue Zeitkategorien erstellen',
    saveChanges: 'Änderungen speichern',
    unsavedChanges: 'Sie haben ungespeicherte Änderungen',
    saveSuccess: 'Zeitkategorien erfolgreich gespeichert',
    saveError: 'Fehler beim Speichern der Zeitkategorien',
    validationError: 'Bitte überprüfen Sie die eingegebenen Werte',
    class: 'Zeitkategorie {{number}}',
    reset: 'Zurücksetzen',
    infoDescription:
      'Hier können Sie die Zeitbereiche für die verschiedenen Zeitkategorien definieren. ' +
      'Jede Zeitkategorie repräsentiert einen Zeitbereich für die Fahrtdauer. ' +
      'Die Bereiche müssen lückenlos aneinander anschließen und dürfen sich nicht überschneiden.',
  },
  vehicleCostFees: {
    title: 'P1 - Preis je Fahrzeugtyp pro Fahrtag',
    new: 'Neuer Preis je Fahrzeugtyp pro Fahrtag',
    edit: 'Preis je Fahrzeugtyp pro Fahrtag bearbeiten',
    infoDescription:
      'Wenn die Anzahl der Fahrzeuge fest ist, aktivieren Sie die Option und tragen den Wert manuell ein. ' +
      'Ist sie nicht fest, wird die Anzahl der Fahrzeuge automatisch berechnet.',
    vehicleType: 'Fahrzeugtyp',
    costFee: 'Preis je Fahrzeugtyp (€)',
    amountOfVehicles: 'Anzahl Fahrzeuge',
    fixed: 'Anzahl Fahrzeuge fest',
    amountOfVehiclesIsFixed: 'Anzahl Fahrzeuge ist fest',
    selectVehicleType: 'Bitte Fahrzeugtyp auswählen',
    noData: 'Kein Preis pro Fahrzeugtyp vorhanden',
    unsavedEntries: 'Nicht gespeicherte Einträge',
    existingFees: 'Bestehende Preise je Fahrzeugtyp',
    addToList: 'Zur Liste hinzufügen',
    saveAll: 'Alle Preise je Fahrzeugtyp pro Fahrtag speichern',
    addedToList: 'Zur Liste hinzugefügt',
    removedFromList: 'Aus Liste entfernt',
    noFeesToSave: 'Keine Preise je Fahrzeugtyp pro Fahrtag zum Speichern',
    allSavedSuccess: '{{count}} Preise je Fahrzeugtyp pro Fahrtag erfolgreich gespeichert',
    updateSuccess: 'Preise je Fahrzeugtyp pro Fahrtag erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Preise je Fahrzeugtyp pro Fahrtag',
    deleteConfirm: 'Möchten Sie diesen Preis je Fahrzeugtyp pro Fahrtag wirklich löschen?',
    deleteSuccess: 'Preis je Fahrzeugtyp pro Fahrtag erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen des Preises je Fahrzeugtyp pro Fahrtag',
    saveError: 'Fehler beim Speichern des Preises je Fahrzeugtyp pro Fahrtag',
    vehicleTypeAlreadyExists: 'Der Fahrzeugtyp wurde schon angelegt',
    entityFee: {
      title: 'P4 - Preis für Overhead/Regie pro Fahrzeug',
      new: 'Neuer Preis für Overhead/Regie pro Fahrzeug',
      edit: 'Preis für Overhead/Regie pro Fahrzeug bearbeiten',
      entityType: 'Typ',
      noData: 'Kein Preis für Overhead/Regie pro Fahrzeug vorhanden',
      createSuccess: 'Preis für Overhead/Regie pro Fahrzeug erfolgreich erstellt',
      createError: 'Fehler beim Erstellen des Preises für Overhead/Regie pro Fahrzeug',
      updateSuccess: 'Preis für Overhead/Regie pro Fahrzeug erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren des Preises für Overhead/Regie pro Fahrzeug',
      deleteConfirm: 'Möchten Sie diesen Preis für Overhead/Regie pro Fahrzeug wirklich löschen?',
      deleteSuccess: 'Preis für Overhead/Regie pro Fahrzeug erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Preises für Overhead/Regie pro Fahrzeug',
      types: {
        VEHICLE: 'Fahrzeug',
      },
    },
  },
  actions: 'Aktionen',
  driver: {
    gender_MALE: 'Fahrer',
    gender_FEMALE: 'Fahrerin',
    gender_DIVERS: 'Fahrer:innen',
    singular: 'Fahrer:in',
    plural: 'Fahrer:innen',
    detail: 'Fahrer',
    list: 'Liste aller Fahrer:innen',
    new: 'Fahrer:in erstellen',
    replacementDriver: 'Ersatzfahrer:in',
    goToDriverDetail: 'Wechsel zu Fahrer:in',
  },
  escort: {
    singular: 'Begleitperson',
  },
  employee: {
    id: 'ID',
    gender_MALE: 'Personal',
    gender_FEMALE: 'Personal',
    gender_DIVERS: 'Personal',
    singular: 'Person',
    singularDelete: 'Person',
    plural: 'Personen',
    detail: 'Person',
    list: 'Liste aller Personen',
    new: 'Person erstellen',
    roles: 'Rollen',
    unavailableFrom: 'nicht verfügbar ab',
    employeeCreated: 'Person erstellt',
    updateSuccessful: 'Person aktualisiert',
    keycloakHint: 'Hinweis Keycloak',
    keycloakImported: 'Import in Keycloak erfolgreich',
    keycloakUpdate: 'Update in Keycloak erfolgreich',
    importedInKc: 'importiert in Keycloak',
    deleteEmployees: 'Möchten Sie diese Personen löschen?',
    deleteEmployee: 'Möchten Sie diese Person löschen?',
    deleteError: 'Fehler beim Löschen einer Person',
    deleteErrorMessage:
      'Die Personen mit den folgenden IDs konnten nicht gelöscht werden. Es bestehen noch Verknüpfungen mit Touren und/oder Fahrzeugen: ',
    deleteErrorMessageSingular:
      'Die Personen konnten nicht gelöscht werden, da noch Verknüpfungen mit Touren und/oder Fahrzeugen bestehen.',
    employeeNumber: 'Personalnummer',
  },
  vehicle: {
    id: 'ID',
    singular: 'Fahrzeug',
    plural: 'Fahrzeuge',
    licensePlate: 'Kennzeichen',
    chassisNumber: 'Fahrgestellnummer',
    endOfAdmission: 'Zulassungsende',
    engine: 'Motortyp',
    adress: 'Fahrzeugstandort',
    vehicleRegistration: 'Fahrzeugzulassung',
    vehicleRegistrationDate: 'Zulassungsdatum',
    usualDriver: 'Standardfahrer:in des Fahrzeugs',
    constitution: 'Zustand des Fahrzeugs',
    unavailableFrom: 'nicht verfügbar ab',
    new: 'Fahrzeug erstellen',
    wheelchair_info: 'Info zu Rollstuhlbeförderung nötig',
    wheelchairSeats_info: 'Info zu Rollstuhlplätzen notwendig',
    liftingPlatform_info: 'Info zu Hebebühne nötig',
    liftingPlatform: 'Hebebühne',
    seats_info: 'Info zu Sitzplätzen nötig',
    licensePlate_info: 'Info zu Kennzeichen nötig',
    transportationOptions: 'Transportoptionen',
    detail: 'Fahrzeug',
    wheelchairSeats: 'davon Rollstuhplätze',
    seats: 'Anzahl Plätze inkl. Rollstuhlplätze ohne Fahrer:in',
    seatsAbbreviated: 'Plätze',
    vehicleModelName: 'Fahrzeug Modellbezeichnung',
    vehicleType: 'Fahrzeugtyp',
    goToVehicleDetail: 'Wechsel zum gewählten Fahrzeug',
    deleteVehicles: 'Möchten Sie diese Fahrzeuge löschen?',
    deleteVehicle: 'Möchten sie dieses Fahrzeug löschen?',
    deleteError: 'Fehler beim Löschen eines Fahrzeugs',
    deleteErrorMessage:
      'Die Fahrzeuge mit den folgenden IDs konnten nicht gelöscht werden. Es bestehen noch Verknüpfungen mit Touren und/oder Planungen: ',
    deleteErrorMessageSingular:
      'Das Fahrzeug konnte nicht gelöscht werden, da noch Verknüpfungen mit Touren und/oder Planungen bestehen.',
    updateError: 'Fehler beim Update des Fahrzeuges',
    updateErrorVehicleUsed:
      'Aktualisierung der Attribute nicht möglich, da das Fahrzeug bereits in Touren und/oder Planungen eingetragen ist.',
    validityOutsideGlobalDate:
      'Am Fahrzeug können keine Änderungen vorgenommen werden, da das Änderungsdatum außerhalb des Zulassungszeitraumes liegt.',
    vehicleTypeOptions: {
      electricity: 'Elektromotor',
      diesel: 'Dieselmotor',
      petrol: 'Benzinmotor',
      hybrid: 'Hybrid',
    },
    transportationCompany_required: 'Verkehrsunternehmen notwendig',
    driverRequired: 'Fahrer:in notwendig',
    vehicleTypeRequired: 'Fahrzeugtyp notwendig',
    tour: {
      tours: 'Touren des Fahrzeuges',
      tours_planned: 'Planungen des Fahrzeugs',
      tours_of_selected_vehicle: 'Anzeige für gewählte Fahrzeuge',
    },
    vehicleListWithoutDateConsideration: 'lade alle Fahrzeuge ohne Datumsfilter',
  },
  vacation: {
    new: 'Ferieneintrag erstellen',
    edit: 'Ferieneintrag editieren',
    delete: 'Ferieneintrag löschen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    template: {
      new: 'Vorlage erstellen',
      isPresent: 'Kalendervorlage verwenden',
      singular: 'Kalendervorlage',
      plural: 'Kalendervorlagen',
      countEntries: 'Anzahl der Einträge',
      noTemplate: 'keine Kalendervorlage',
    },
    validFrom: 'gültig von',
    validUntil: 'gültig bis',
  },
  basicData: {
    singular: 'Einstellung',
    plural: 'Einstellungen',
  },
  interkommunalerLastenausgleich: {
    title: 'Interkommunaler Lastenausgleich',
    editLastenausgleichAttributes: 'Attribute eintragen oder ändern',
    selectSchool: 'Auswahl Schule',
    setParameters: 'Parameter einstellen',
    parametersAndLayout: 'Parameter einstellen',
    stichtag: 'Schulstatistischer Stichtag',
    stichtagTooltip:
      'Nur diese eine Woche des Stichtages zählt. Die Touren von Mo bis So in der genannten Kalenderwoche werden für alle Fahrtage des Jahres hochgerechnet.',
    faktorDefaultPercent: 'Faktor (Prozent)',
    abzugDefaultEuro: 'Abzug in EUR',
    saveAndSend: 'Ausgabe erstellen',
    setGlobalDate: 'Globales Datum eintragen',
    setConfigDate: 'Standard eintragen',
  },
  exportPage: {
    navSubheader: 'Exporte',
    title: 'Ausdrucke und Abrechnungen',
    generate: 'Ausdrucke erstellen',
    dateRange: 'Zeitraum',
    today: 'Heute',
    tomorrow: 'Morgen',
    currentWeek: 'Aktuelle Woche',
    lastWeek: 'Letzte Woche',
    nextWeek: 'Nächste Woche',
    currentMonth: 'Aktueller Monat',
    lastMonth: 'Letzter Monat',
    lastThreeMonths: 'Letzte drei Monate',
    accountingType: 'Abrechnungstyp',
    reset: 'Zurücksetzen',
    steps: {
      last: 'letzter Schritt',
      finished: 'Alle Schritte abgeschlossen',
      finish: 'abschließen',
      generate: 'Erstellen',
      reset: 'Neu anfangen',
      continue: 'weiter',
      back: 'zurück',
      finishedInfoStart: 'Der ',
      finishedInfoEnd:
        ' wird jetzt im Hintergrund erstellt. Sie können daraus einen Favoriten anlegen, um diesen jederzeit erneut aufrufen zu können.',
    },
    tours: {
      label: 'Auswahl Schulen, Touren oder Tourbündel',
      title: 'Touren',
      tours: 'Touren',
      planning: 'Planungen',
      schools: 'Schulen',
      transportationCompany: 'Verkehrsunternehmen',
      vehicles: 'Fahrzeuge',
      employees: 'Personal',
    },
    datesFormat: {
      label: 'Auswahl Zeitraum und Ausgabetyp',
      title: 'Zeitraum und Abrechnung',
      from: 'von',
      until: 'bis',
    },
    exportTypes: 'Abrechnung oder Ausdruck',
    exportTimetable: 'Fahrplan erstellen',
    exportTimetableHintStart: 'Fahrplan erstellen. Nur Touren die am ',
    exportTimetableHintEnd: 'gültig sind.',
    exportGroupEnum: {
      ACCOUNTING: 'Abrechnungsbogen',
      DRIVING_SERVICE_INVOICE: 'Fahrdienstteilnehmer',
      TENDER: 'Ausschreibung',
      TIMETABLE: 'Fahrplan',
      TOUR_CLASS: 'Zeitkategorie',
      UNKNOWN: 'Verschiedenes',
    },
    parameters: {
      label: 'Auswahl Ausgabeparameter',
      title: 'Ausgabeparameter',
      useEmptyKmCost: 'Leerfahrten ausgeben',
      respectAbsence: 'Abwesenheiten berücksichtigen',
      respectWaitingTime: 'Wartezeit berücksichtigen',
      overrideOccupiedDistance: 'APV-Km',
      showCosts: 'Preise ausgeben',
      groupByCostcenters: 'Gruppierung nach Kostenbereichen',
      showKm: 'Segmentkilometer anzeigen (nur bei Fahrplänen)',
      invoiceWithZeroVat: 'Gesamte Abrechnung mit 0 % MwSt.',
      wheelchairTransportWithZeroVat: 'Rollstuhlbeförderung: Komplette Tour mit 0 % MwSt.',
      wheelchairStudentsProportionallyWithZeroVat:
        'Nur im Rollstuhl beförderte Schüler anteilig mit 0 % MwSt.',
      noParameters: 'Derzeit keine erweiterten Parameter!',
    },
    favorites: {
      favoriteAccounting: 'Abrechnungsfavoriten',
      favoriteAccountingInfo:
        'Erweitern Sie die Exportgruppen und markieren Sie Ihre Favoriten zum Drucken.',
      noFavorites:
        'Noch keine Favoriten gespeichert. Erstellen Sie Exporte als Favoriten, um sie in Gruppen anzuzeigen.',
      favoriteCreate: 'Favorit speichern',
      favoritePrint: 'Favoriten drucken',
      favoriteDelete: 'Favoriten löschen',
      favoriteType: 'Typ',
      favoriteLoad: 'Favoriten laden',
      favoriteName: 'Bezeichnung',
      openPopUp: 'Favoriten anlegen',
      saveAs: 'als Favorit speichern',
    },
  },
  excelImport: {
    singular: 'Excel-Import',
    plural: 'Excel-Importe',
    upload: 'Excel-Datei hochladen',
    search: 'Suche Excel',
    column: 'Spalte in Excel',
    columnWithError: 'Fehler in diesen Spalten',
    row: 'Zeile in Excel',
    corresponding_field: 'zugewiesenes Feld in TerraIndividual',
    existingEntry: 'Bestehender Eintrag',
    importedEntry: 'Importierter Eintrag',
    conflictingFields: 'Konfliktfelder',
    duplicateKeyFields: 'Geprüfte Felder',
    duplicatesFound: 'Es wurden {{count}} Duplikate erkannt.',
    overwrite: 'Überschreiben',
    conflictResolution: {
      question: 'Sollen folgende Einträge überschrieben werden?',
      description:
        'Wählen Sie „Ja“, um den bestehenden Eintrag mit den importierten Daten ' +
        'zu überschreiben. Wählen Sie „Nein“, um den bestehenden Eintrag unverändert zu' +
        ' lassen und diese Excel-Zeile nicht zu importieren. Bei Bestätigung wird das Excel-File' +
        ' mit Berücksichtigung der Konflikte importiert.',
      alreadyResolvedWarning:
        'Diese Konfliktlösung wurde bereits bestätigt und kann nicht erneut abgeschickt werden.',
      resolvedLabel: 'Konfliktlösung bestätigt',
      overwriteValidFromLabel: 'Überschreiben ab',
      overwriteValidFromInfo: 'Die ausgewählten Einträge werden ab diesem Datum überschrieben.',
      submit: 'Konfliktlösung bestätigen',
    },
    common: {
      yes: 'Ja',
      no: 'Nein',
    },
    fieldTypes: {
      text: 'Text (max. 255 Zeichen)',
      transportationCompany: 'Name muss angelegtem Verkehrsunternehmen entsprechen',
      transportationModel: 'Name muss angelegten Standardwochen entsprechen',
      vehicleSeats: 'inklusive Rollstuhlplätze',
      vehicleDriverRelation:
        'Eindeutiges Wertepaar (ID) zur automatischen Zuordnung von Fahrpersonal und Fahrzeugen. Hierfür müssen die IDs in den Importdateien für Perosnal und Fahrzeuge hinterlegt sein.',
      number: 'Zahl',
      coordinate: 'Koordinate WGS84, EPSG: 4326 (Bsp: 47,90857)',
    },
    importTypeTitle: {
      STUDENTS: 'Schüler',
      VEHICLES: 'Fahrzeug',
      EMPLOYEES: 'Fahrer:innen',
      PUBLIC_TRANSPORTATION: 'ÖPNV-Haltestellen',
    },
    typesSuccess: {
      STUDENTS: 'Schüler-Excel importiert',
      VEHICLES: 'Fahrzeug-Excel importiert',
      EMPLOYEES: 'Fahrer:innen-Excel importiert',
      PUBLIC_TRANSPORTATION: 'ÖPNV-Haltestellen-Excel importiert',
    },
    typesError: {
      STUDENTS: 'Schüler-Excel Fehler',
      VEHICLES: 'Fahrzeug-Excel Fehler',
      EMPLOYEES: 'Fahrer:innen-Excel Fehler',
      PUBLIC_TRANSPORTATION: 'ÖPNV-Haltestellen-Excel Fehler',
    },
    excelTooLarge: 'Exceldatei zu groß: Max. 100.000 Zeilen möglich',
    excelNotFound: 'Excel nicht gefunden oder nicht im .xls oder .xlsx Format',
    upload_success: 'Upload erfolgreich',
    excelHeaders: 'Excel Spaltennamen',
    assignment: 'Zuordnung in TerraIndividual',
    uploadCustomMapping: 'speichern in Datenbank',
    asnyc_loading_activated:
      'Sie können weiter arbeiten und werden über den Fortschritt informiert',
    attributes: {
      HOUSE_NUMBER: 'Hausnummer',
      PHONE: 'Telefon',
      MOBILE_NUMBER: 'Mobilnummer',
      CHASSIS_NUMBER: 'Fahrgestellnummer',
      END_OF_ADMISSION: 'Zulassungsende',
      TRANSPORT_FROM: 'Beförderung von',
      TRANSPORT_UNTIL: 'Beförderung bis',
      FIRSTNAME: 'Vorname',
      EXTENSION: 'Erweiterung',
      EMAIL: 'E-Mail',
      GENDER: 'Geschlecht',
      COMMENT: 'Kommentar',
      DISTRICT: 'Ortsteil',
      KREIS: 'Kreis',
      LOT_NUMBER: 'Los',
      WHEELCHAIR_SITTING: 'sitzend im Rollstuhl',
      LASTNAME: 'Nachname',
      POSTAL_CODE: 'PLZ',
      EMPLOYEE_NUMBER: 'Personalnummer',
      BIRTHDAY: 'Geburtsdatum',
      INSTRUCTION: 'Anweisungen',
      MOBILITY: 'Mobilität',
      ESCORT_INDIVIDUAL: 'Individualbegleitung',
      STREET: 'Strasse',
      CITY: 'Ort',
      ADDITIONAL_INFORMATION: 'Zusatzinformation',
      JUSTIFICATION: 'Begründung',
      ESCORT_IN_BUS: 'Busbegleitung',
      UTILITY: 'Hilfsmittel',
      WHEELCHAIR: 'Rollstuhl',
      HAND_TO_HAND: 'Hand zu Hand',
      TRANSPORTATION_COMPANY: 'Verkehrsunternehmen',
      VEHICLE_KEY_EXCEL_IMPORT: 'Fahrzeug-Fahrer Zuweisung',
      NAME: 'Name',
      LICENSE_PLATE: 'Nummernschild',
      VEHICLE_MODEL_NAME: 'Modellname',
      SEATS: 'Plätze',
      WHEELCHAIR_SEATS: 'Rollstuhlplätze',
      VEHICLE_TYPE: 'Fahrzeugtyp',
      VEHICLE_REGISTRATION_DATE: 'Zulassungsdatum',
      LIFTING_PLATFORM: 'Lift',
      DRIVER_KEY_EXCEL_IMPORT: 'Fahrer-Fahrzeug Zuweisung',
      PARENT_ONE_SALUTATION: '1. Elternteil Anrede',
      PARENT_ONE_FIRST_NAME: '1. Elternteil Vorname',
      PARENT_ONE_LAST_NAME: '1. Elternteil Nachname',
      PARENT_ONE_STREET: '1. Elternteil Straße',
      PARENT_ONE_HOUSE_NUMBER: '1. Elternteil Hausnummer',
      PARENT_ONE_DISTRICT: '1. Elternteil Ortsteil',
      PARENT_ONE_POSTAL_CODE: '1. Elternteil PLZ',
      PARENT_ONE_CITY: '1. Elternteil Ort',
      PARENT_ONE_EMAIL: '1. Elternteil E-Mail',
      PARENT_ONE_PHONE: '1. Elternteil Telefon',
      PARENT_TWO_SALUTATION: '2. Elternteil Anrede',
      PARENT_TWO_FIRST_NAME: '2. Elternteil Vorname',
      PARENT_TWO_LAST_NAME: '2. Elternteil Nachname',
      PARENT_TWO_STREET: '2. Elternteil Straße',
      PARENT_TWO_HOUSE_NUMBER: '2. Elternteil Hausnummer',
      PARENT_TWO_DISTRICT: '2. Elternteil Ortsteil',
      PARENT_TWO_POSTAL_CODE: '2. Elternteil PLZ',
      PARENT_TWO_CITY: '2. Elternteil Ort',
      PARENT_TWO_EMAIL: '2. Elternteil E-Mail',
      PARENT_TWO_PHONE: '2. Elternteil Telefon',
      LATITUDE: 'Latitude',
      LONGITUDE: 'Longitude',
      SCHOOL_CLASS: 'Schulklasse',
      SCHULTRAEGER: 'Schulträger',
      FESTSTELLUNGSBESCHEID_VALID_UNTIL: 'Feststellungsbescheid gültig bis',
      FOERDERSCHWERPUNKT: 'Förderschwerpunkt',
      ROW_IS_NULL: 'komplette Zeile ist leer',
      COST_AREA: 'Kostenstelle',
      COSTCENTER: 'Kostenbereich',
      COST_PROVIDER: 'Kostenträger',
      KINDERGARTEN: 'Kindergarten',
      BAFOEG: 'BAföG',
    },
  },
  days: {
    days: 'Tage',
    mo: 'Mo',
    tu: 'Di',
    we: 'Mi',
    th: 'Do',
    fr: 'Fr',
    sa: 'Sa',
    su: 'So',
    1: 'Mo',
    2: 'Di',
    3: 'Mi',
    4: 'Do',
    5: 'Fr',
    6: 'Sa',
    7: 'So',
  },
  contextMenu: {
    changesValidFrom: 'Änderungen gültig ab',
    tour: {
      tourBundle: 'Tour-Bündel',
      tourCosts: 'Tourpreise',
      costOccupiedKm: 'Besetztkilometer (EUR)',
      costEmptyKm: 'Leerkilometer (EUR)',
      costFlatRate: 'Pauschale (EUR)',
      costAddition: 'Zuschlag (EUR)',
      vehicleDriverEscort: 'Fahrzeug, Personal und Leerfahrt',
      changedVehicleHintContextMenu:
        'Bei Änderung des Fahrzeugs werden die Leerfahrten ab dem gewählten Datum aktualisiert, es sei denn, die Leerfahrt-Hin und Leerfahrt-Rück werden unten überschrieben.',
      virtualVehicleEmptySectionHint:
        'Mindestens eine ausgewählte Tour hat zum gewählten Datum ein virtuelles Fahrzeug. Wählen Sie ein Fahrzeug aus, um auch Leerfahrten zuzuweisen.',
      infoHeader: 'Es werden nur ausgewählte Werte übernommen',
      toursNotUpdatable:
        'Update teilweise erfolgreich. Bei folgenden Touren liegt das Änderungsdatum außerhalb des Gültigkeitszeitraums: ',
      reroute: 'Routen erneut berechnen',
      rerouteCurrent: 'erneut berechnen (bestehende Optimierung)',
      rerouteTime: 'optimieren nach Zeit',
      rerouteDistance: 'optimieren nach Strecke',
      minutesAroundSchool: 'Minuten vor Schulstart/nach Schulende',
      minutesAroundSchoolHint: 'nur ganze Zahlen (keine Kommazahlen)',
      tourNameNumberAbbreviation: 'Tour-Name, Nummer und Kürzel',
    },
    student: {
      assignTransportationModel: 'Standardwoche zuweisen',
      editTransportDates: 'Beförderungszeitraum ändern',
      autoAssignPublicTransportationPlace: 'ÖPNV Haltstellen automatisch zuweisen',
      autoAssignPublicTransportationPlaceInfo:
        'Hiermit wird den ausgewählten Schüler:innen automatisch der nächstgelegene ÖPNV-Haltestelle' +
        ' per Luftlinie zugewiesen.',
      autoAssignPublicTransportationPlaceSuccess: 'ÖPNV-Haltestellen automatisch zugewiesen.',
      autoAssignPublicTransportationPlaceError:
        'ÖPNV-Haltestellen konnten nicht automatisch zugewiesen werden, weil für mindestens eine Person kein ÖPNV Halt ' +
        'im Umkreis gefunden wurde.',
      assignTransportationModelHint:
        'Die Änderungsmöglicheiten sind bewusst begrenzt, um unvorhergesehene Änderungen in der Vergangenheit zu vermeiden.\n\nSchüler:innen ohne Touren: Änderung jederzeit möglich.\nSchüler:innen mit Touren: Änderung nur ab dem heutigen Datum möglich (Schüler:innen werden ab dem "gültig ab" Datum aus allen(!) Touren entfernt).',
      assignTransportationModelHintTwo:
        'Die Standardwoche ist eine Schablone, mit der Kalendereinträge für Schüler:innen erstellt werden können.\n\nDie Standardwoche wird für den gewählten Zeitraum gesetzt und die Kalendereinträge entsprechend erstellt. Zuvor werden alle durch Standardwochen gesetzten Kalendereinträge ab dem "gültig ab" Datum gelöscht. Manuell erstellte Kalendereinträge bleiben erhalten.',
      partial_success: 'Teilweise erfolgreich',
      students: 'Schüler:innen',
      students_assigned: 'angepasst',
      students_failed: 'nicht angepasst',
      reasons: 'Gründe',
      differentSchools: 'Bitte nur Schüler:innen einer Schule auswählen',
      errorStudentInPastTour: 'Schüler:in in vergangenen Touren',
      errorStudentInDifferentSchool: 'Schüler:in in unterschiedlichen Schulen',
      errorInvalidStartDate: 'Startdatum muss an einem Montag sein',
      errorGeneralError: 'Ein Fehler ist aufgetreten',
      createTemplatedDocuments: 'Dokumente generieren',
    },
  },
  employeeApp: {
    title: 'Angestellten-App',
    keycloakImport: 'Import der Angestellten nach Keycloak',
    syncKc: 'Syncronisiere mit Angestellten-App',
    import: 'Import der Angestellten nach Keycloak',
    timestampExportError: 'Fehler bei den ausgewählten Zeiten',
    importTableHeaders: {
      imported: 'importiert',
      username: 'Username / E-Mail',
      fullName: 'Name des Angestellten',
      errorType: 'Fehlertyp',
      errorHint: 'Hinweis',
    },
    importErrorType: {
      SEND_ACTIONS_EMAIL: 'Fehler im E-Mail-Versand',
      CREATE_USER: 'Fehler bei der User-Erstellung',
      FETCHING_TOKEN: 'Fehler bei der Authentiifizierung',
      SETTING_PASSWORD: 'Fehler beim Setzen des Initialpasswortes',
      NONE: 'kein Fehler',
      UPDATE_USER: 'Fehler beim User-Update',
    },
    importError: {
      FAILED_TO_SEND_EXECUTION_EMAIL:
        'Fehler in der Keycloak API. Bitte kontaktieren Sie Terraplan',
      USER_EXISTS_SAME_USERNAME: 'E-Mailadresse bereits vergeben',
      UNKNOWN_ERROR: 'unbekannter Fehler',
    },
    messages: {
      plural: 'Nachrichten',
      singular: 'Nachricht',
      employeeNumber: 'Angestellten-Nr.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      mobile: ' Mobilnummer',
      email: 'E-Mail',
      employeeId: 'Angestellten-ID',
      send: 'Nachricht senden',
      select_date: 'Nachricht sichtbar ab',
      send_message_to: 'Nachricht senden an',
      message_history: 'Nachrichtenverlauf',
      messages_for: 'Nachrichten gesendet an: ',
      at: 'am',
    },
    export: {
      singular: 'Export',
      excel_download: 'Download Excel',
      download_work_times: 'Arbeitszeiten herunterladen',
      info: 'Excel-Sheet der Arbeitszeiten aller Mitarbeiter:innen',
    },
    comparison: {
      title: 'Track-Tour Vergleich',
      id: 'ID',
      trackId: 'Track',
      tourId: 'Tour',
      employeeId: 'Fahrer:in',
      trackDate: 'Datum',
      createdAt: 'Erstelldatum',
      algorithm: 'Vergleichsart',
      durationDifferenceAbsolute: 'Zeit des Tracks (Sek.)',
      durationDifferenceRelative: 'Verhältnis Zeit (Sek.)',
      distanceDifferenceAbsolute: 'Strecke des Tracks (m)',
      distanceDifferenceRelative: 'Verhältnis Strecke (m)',
      otherResult: 'Sonstiges',
      noTourAtDate: 'Tour hat an diesem Datum keine Fahrt',
      noTour: 'Track hat keine Tour',
    },
  },
  tourWizard: {
    makeAdjustmentsInEvent: 'Bitte folgen Sie den Anweisungen, um Anpassungen am Event vorzunehmen',
    checkAffectedTours: 'Prüfung betroffener Touren',
    createDeviationEvent: 'Erstellen Sie ein neues Abweichungsereignis',
    alternativeTours: 'Liste alternativer Touren',
    assignStudent: 'Weisen Sie dem Fahrgast eine der unten aufgeführten alternativen Touren zu.',
    createNewTour: 'Erstellen Sie eine Tour.',
    enterTourInformation: 'Tragen Sie die Tourinformationen ein.',
    addStudentToTour: 'Fahrgast zur ausgewählten Tour hinzufügen',
    newDeviationEventInformation: 'Tragen Sie Informationen zum Abweichungsereignis ein.',
    // FIXME: switch back to old translation again after fixing https://terraindividual.atlassian.net/browse/TICL-2993
    selectAlternativeToursOrCreateNewTour: 'Sie können eine Tour für den Fahrgast anlegen.',
    //  'Sie können entweder eine der alternativen Touren auswählen oder eine neue Tour für den Fahrgast anlegen.',
    affectedTours: 'Betroffene Touren',
    affectedStudents: 'Betroffene Fahrgäste',
    studentsRemainInTour: 'Fahrgast verbleibt in den Touren',
    removeStudentsFromTours: 'Fahrgast aus Touren austragen',
    addStudentToAlternativeTour: 'Fahrgast zur ausgewählten Tour hinzufügen',
    showAlternativeTours: 'alternative Touren anzeigen',
    studentsRemainInTourInformation:
      'Der Fahrgast verbleibt mit seinem neuen Haltepunkt in den bisherigen Touren und die Touren werden ernneut berechnet.',
    removeStudentsFromToursInformation:
      'Der Fahrgast wird aus den Touren ausgetragen und die Touren werden anschließend erneut berechnet.',
    addStudentToAlternativeTourInformation: 'Der Fahrgast wird der ausgewählten Tour hinzugefügt.',
    enable: 'aktivieren',
    disable: 'deaktivieren',
    advancedFiltering: 'erweiterte Filterung',
    warningOnlySelectOne: 'Bitte einzelne Tour auswählen',
    changedToursInformationAfterChangeOfPlaceOrSchoolHour: 'Änderung von Touren',
    followingToursWereChanged:
      'Die folgenden Touren wurden nach der Herausnahme der ' +
      'Schüler:in bzw. der Anpassung des Events erneut erstellt oder geändert:',
    confirmCloseMessage:
      'Wenn Sie den Dialog schließen, wird die Schüler:in aus allen betroffenen Touren ab dem ' +
      'Datum der Adressänderung entfernt.',
    confirmClose: 'Tour-Wizard schließen',
  },
  tourTransform: {
    error: 'Es konnten nicht alle Touren umgewandelt werden.',
    partiallyDone: ' nicht umgewandelte Touren.',
    resultId: 'Ergebnis ID:',
    convertedTours: 'Umgewandelte Touren:',
    notConvertedAndOverlapTours: 'Touren, die nicht umgewandelt werden konnten und Konflikte:',
    overlapTours: 'überlappende Touren',
    conflictingTours: 'Touren mit Konflikten',
    conflictTour: 'Konflikttour',
    conflictingPlaces: 'Ortsunstimmigkeit (berücksichtigt nur erste Planungswoche)',
    multipleTransportationModel:
      'Für den Tour-Zeitraum sind mehrere Standardwochen im Kalender vermerkt. Bitte passen Sie' +
      ' die Touren oder Events entsprechend an.',
    noPlaceDifferences: 'identische Orte',
    noOverlappingTour: 'keine überlappenden Touren',
  },
  transportationNeedCheck: {
    info: 'Ergebnis der Prüfung des Beförderungsbedarfs',
    infoTitle: 'Übersicht des Beförderungsbedarfs ausgewählter Schüler:innen',
    createTitle: 'Beförderungsbedarf prüfen',
    toDates: 'Hinfahrten',
    fromDates: 'Rückfahrten',
    transferDates: 'Transferfahrten',
    unfulfilledTransportationNeed: 'Beförderungsbedarf nicht gedeckt',
    fulfilledTransportationNeed: 'Beförderungsbedarf gedeckt',
    studentsWithUnfulfilledTransportationNeed:
      'Anzahl der Schüler:innen mit nicht gedecktem Beförderungsbedarf:',
    amountOfCheckedStudentsInfo: 'Anzahl der überprüften Schüler:innen:',
    datesWithNotFulfilledTransportationNeed: 'Zeiträume für nicht gedeckten Beförderungsbedarf',
    checkFrom: 'prüfen ab',
    checkUntil: 'prüfen bis',
    startCheck: 'Prüfung starten',
    dateRangeForCheck: 'Prüfungszeitraum',
    dateRangeForCheckFail: 'fehlerhafter Zeitraum',
    transportationNeedCalculationTitle: 'Prüfung Beförderungsbedarf',
    transportationNeedCalculation: ' wird berechnet',
    transportationNeedCalculationFail: ' ist fehlgeschlagen',
    studentsWithTransportationNeedTo: 'Für Hinfahrten',
    studentsWithTransportationNeedTransfer: 'Für Transferfahrten',
    studentsWithTransportationNeedFrom: 'Für Rückfahrten',
  },
  globalMap: {
    title: 'Karte',
    clearMap: 'Karte leeren',
    openList: 'Liste öffnen',
    closeList: 'Liste schließen',
    fullscreen: 'Vollbild',
    zoomIn: 'vergrößern',
    zoomOut: 'verkleinern',
    opacity: 'Deckkraft anpassen',
    person: 'Pers.',
    zoomInMap: 'auf Feature zoomen',
    search: 'Adresse suchen',
    legend: 'Legende',
    base: 'Base',
    filterBySchoolTransportationTime: 'Touren und Schüler:innen filtern',
    filterBySchoolTransportationTimeTooltip:
      'Touren werden nach allen gewählten Attributen gefiltert. Schüler:innen werden aufgrund der gewählten Schule gefiltert.',
    studentButtonToolTip: 'Bitte markieren Sie genau eine Tour',
    filterEnabled: 'Aktivieren',
    filterDisabled: 'Deaktivieren',
    tourReason: 'Tour-Grund',
    tourType: 'Tour-Art',
    selectedSchools: 'Ausgewählte Schulen',
    showFilters: 'Filter anzeigen',
    hideFilters: 'Filter ausblenden',
    removeSchool: 'Schule löschen',
    tourStop: 'Stopps anzeigen',
    recalculateTour: 'Tagesaktuelle Touren erneut berechnen',
    noOfRowsSelected: ': {{selected}} / {{total}}',
    totalRows: 'Gesamt {{total}}',
    needHelp: 'Benötigen Sie Hilfe?',
    showEmptySections: 'Leerfahrten einblenden',
    showDirectionArrows: 'Richtungspfeile einblenden',
    showPublicTransports: 'ÖPNV-Haltestellen einblenden',
    showPublicTransportConnections: 'ÖPNV-Haltestellen Zuordnung einblenden',
    publicTransportConnectionLine: 'Luftlinie Heimatadresse ↔ ÖPNV-Haltestelle',
    showMandatoryRoutingPoints: 'Zwangspunkte einblenden',
    showRoadblocks: 'Straßensperrung einblenden',
    mapType: 'Hintergrundkarten',
    osm: 'OpenStreetMap',
    wmts: 'Basemap.de',
    moreOptions: 'Weitere Optionen',
    noToursInMap: 'Am gewählten Datum konnten keine Touren geladen werden.',
    noToursInMapInfo:
      'Ursachen hierfür könnten sein: Touren fahren nicht am gewähltem Datum oder Das gewählte Datum liegt in den Ferien',
    tourTimeline: 'Verknüpfte Touren anzeigen',
    noTourNumber: 'Für die ausgewählte Tour wurde keine Tour-Nummer gefunden',
  },
  placeType: {
    HOME: 'Schüler:in Haltepunkt',
    SCHOOL: 'Einrichtung',
    TECHNICAL: 'Technisch',
    TRANSPORTATION: 'Transport',
    SCHOOLCENTER: 'Schulzentrum',
    PLACE_PICKER_GEOCODED: 'Freihandauswahl',
    PUBLIC_TRANSPORT: 'ÖPNV',
    MANDATORY_ROUTING_POINT: 'Zwangspunkt',
  },
  placeManagement: {
    title: 'Orte / Haltepunkte',
    type: 'Ortstyp',
    new: 'Haltepunkt erstellen',
    editPlace: 'Haltepunkt aktualisieren',
    delete: 'Haltepunkt löschen',
    deleteTitle: 'Löschen des Haltepunktes fehlgeschlagen',
    deleteError:
      'Löschen fehlgeschlagen, da Haltepunkt noch im System verwendet wird (Bsp: Schüler:in, Schule, Tour, Event, ...)',
  },
  documentManagement: {
    title: 'Titel',
    date: 'Datum',
    titleRequired: 'Titel ist erforderlich',
    upload: 'hochladen',
    download: 'herunterladen',
    uploadSuccess: 'Dokument erstellt',
    documentTooLarge: 'Dokument zu groß',
    errorSaving: 'Fehler beim Speichern des Dokuments',
    origFilename: 'Name',
    size: 'Größe',
    fileType: 'Typ',
    username: 'Benutzer',
    delete: 'Löschen',
    errorLoadingDocuments: 'Fehler beim Abrufen der Dokumente',
    askDeleteDocument: 'Wollen Sie dieses Dokument wirklich löschen?',
  },
  tourPlanningWizard: {
    warning:
      'Bitte nur Hintouren auswählen. Diese Hintouren müssen den gleichen Gültigkeitszeitraum haben',
    title: 'Wizard Rücktouren-Planung',
    nextStep: 'weiter',
    status: 'Status',
    planning: 'Planung im Hintergrund gestartet ...',
    statusOptions: {
      NO_TOUR: 'gleiche Konstellation nicht möglich',
      TOUR: 'gleiche Konstellation möglich',
    },
    matrixHeaders: {
      id: 'ID',
      name: 'Tour',
      student: 'Schüler:in',
      moFrom: 'Mo',
      tuFrom: 'Di',
      weFrom: 'Mi',
      thFrom: 'Do',
      frFrom: 'Fr',
    },
    close: 'Wizard schließen',
  },
  roadblockManagement: {
    label: 'Straßensperrung (Touren mit Datumsfilter)',
    listTitle: 'Straßensperrungen',
    roadblockPoint: 'Straßensperrung',
    title: 'Straßensperrungen',
    type: 'Ortstyp',
    new: 'Von vorn beginnen',
    edit: 'Straßensperrung aktualisieren',
    delete: 'Straßensperrung löschen',
    deactivate: 'Straßensperrung deaktivieren',
    activate: 'Straßensperrung aktivieren',
    deactivateInfo:
      'Deaktivierte Straßensperrungen werden bei zukünftigen Touren nicht berücksichtigt. Betroffene Touren müssen bei Deaktivierung der Straßensperrung manuell neuberechnet werden. \n\n Möchten Sie die Straßensperrung wirklich deaktivieren?',
    deleteTitle: 'Löschen der Straßensperrung fehlgeschlagen',
    deactivateTitle: 'Deaktivieren der Straßensperrung fehlgeschlagen',
    validFrom: 'Gültig von',
    validUntil: 'Gültig bis',
    save: 'Straßensperrung erstellen',
    affectedTours: 'Betroffene Touren (Ohne Datumsfilter)',
    createRoadblock: 'Straßensperrung anlegen',
    unnamed: 'Unbekannter Name',
    infoTitle: 'Informationen zu Straßensperrungen',
    infoText:
      'Eine angelegte Straßensperrung ist gültig nach dem Erstellen und ist zeitunabhängig. Touren, die bereits ' +
      'im System hinterlegt sind, müssen neu berechnet werden. Touren die nachträglich erstellt werden, berücksichtigen ' +
      'alle bereits angelegten Straßensperrungen.',
    deleteError: 'Error deleting roadblock',
    rerouteAffectedTours: 'Betroffene Touren neu berechnen',
    rerouteAffectedToursDescription:
      'Alle ausgewählten Touren werden mit der von Ihnen ausgewählten Methode' +
      ' neu berechnet. Die neu berechneten Touren sind weiterhin unter den betroffenen Touren der ' +
      'Straßensperrungen zu finden. Es werden keine Tourzeiträume angepasst.',
    noToursSelected: 'No tours selected',
    noToursToReroute: 'No tours available to reroute',
    rerouteRequestSuccessful:
      'Die Neuberechnung der betroffenen Touren wurde erfolgreich abgeschickt.',
    rerouteFailed:
      'Das Rerouting der betroffenen Touren ist fehlgeschlagen. Bitte wenden sie sich an den' +
      ' Support.',
    reroute: 'Routen erneut berechnen',
    inactiveRoadblockNoTours:
      'Die ausgewählte Straßensperrung is deaktiviert. ' +
      'Aktivieren sie die Straßensperrung um betroffene Touren zu sehen.',
    selectRoadblockToViewTours:
      'Wählen Sie eine Straßensperrung aus, um betroffene Touren anzuzeigen.',
  },
  analysis: {
    plural: 'Auswertungen',
    singular: 'Auswertung',
  },
  releaseNotes: {
    title: 'Neuigkeiten',
    description: 'Neue Funktionen und Verbesserungen in TerraIndividual',
    open: 'Neuigkeiten öffnen',
    close: 'Neuigkeiten schließen',
    view: 'Ansehen',
    dismiss: 'Hinweis ausblenden',
    version: 'Version',
    latest: 'Aktuell',
    loading: 'Neuigkeiten werden geladen …',
    unavailable: 'Die Neuigkeiten konnten momentan nicht geladen werden.',
    empty: 'Aktuell sind keine Neuigkeiten vorhanden.',
    changeTypes: {
      new: 'Neu',
      improved: 'Verbessert',
      fixed: 'Behoben',
    },
  },
  timelineGroup: {
    TO: 'Hin',
    FROM: 'Rück',
    VEHICLE: 'Fahrzeuge',
    EMPLOYEE: 'Personal',
    students: 'Schüler',
  },
};

export default de;
